import React from "react"

export const LaunchesComplete = () => {
  return (
    <svg
      width="222"
      height="132"
      viewBox="0 0 222 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.151578"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M180.616 42.7944C171.683 52.7351 161.946 53.2197 147.442 45.4701C132.939 37.7205 137.685 22.088 146.618 12.1472C153.25 4.76731 161.788 -0.458956 169.576 8.21879C171.129 9.94954 171.477 12.2547 171.776 14.6766L171.82 15.0318C171.827 15.0911 171.834 15.1505 171.842 15.2099L171.886 15.5671L171.931 15.925C172.333 19.0304 172.975 22.1979 176.22 24.494C181.628 28.3207 189.548 32.8537 180.616 42.7944Z"
        fill="#6ACBDD"
      />
      <path
        opacity="0.151578"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M139.23 108.003C115.745 131.983 91.2676 132.16 55.7218 111.175C20.176 90.1912 33.7749 51.4893 57.2598 27.5098C74.6949 9.70759 96.6794 -2.48961 115.278 20.106C119.168 24.8325 119.663 31.0021 120.169 37.4333L120.24 38.3322C120.899 46.586 121.837 55.1778 130.184 61.635C143.337 71.8097 162.715 84.024 139.23 108.003Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M180.141 112.048C180.141 112.048 180.225 112.064 180.385 112.094C180.465 112.109 180.563 112.128 180.679 112.15C180.799 112.167 180.936 112.185 181.093 112.204C181.252 112.227 181.423 112.237 181.613 112.252C181.803 112.272 182.009 112.272 182.23 112.272C182.285 112.273 182.343 112.273 182.4 112.273C182.458 112.268 182.514 112.264 182.574 112.26C182.628 112.255 182.679 112.255 182.735 112.246C182.794 112.236 182.857 112.225 182.918 112.215C183.16 112.17 183.347 112.101 183.533 112.026C183.891 111.872 184.212 111.725 184.657 111.642C185.098 111.555 185.588 111.566 186.109 111.681C186.637 111.793 187.169 112.003 187.725 112.219C188.285 112.437 188.862 112.678 189.549 112.889C189.902 112.992 190.255 113.085 190.696 113.152C190.877 113.176 191.022 113.202 191.24 113.222C191.341 113.233 191.446 113.244 191.544 113.252L191.836 113.268C192.614 113.311 193.358 113.208 193.883 113.084C194.36 112.979 194.754 112.988 195.255 113.128C195.321 113.146 195.399 113.165 195.458 113.183L195.629 113.237C195.742 113.268 195.86 113.316 195.975 113.354C196.204 113.435 196.426 113.521 196.639 113.606C196.855 113.69 197.062 113.774 197.271 113.851C197.322 113.869 197.375 113.888 197.426 113.906L197.464 113.92L197.496 113.932L197.515 113.938L197.592 113.961C197.694 113.992 197.786 114.024 197.906 114.051C198.357 114.168 198.746 114.204 199.06 114.223C199.374 114.24 199.609 114.234 199.768 114.231C199.926 114.226 200.01 114.224 200.01 114.224C200.01 114.224 199.925 114.218 199.758 114.205C199.596 114.193 199.356 114.168 199.062 114.131C198.77 114.09 198.41 114.02 198.084 113.911C198.005 113.888 197.913 113.847 197.82 113.811L197.75 113.783L197.733 113.776C197.755 113.784 197.729 113.774 197.729 113.773L197.696 113.757L197.564 113.697C197.386 113.612 197.2 113.523 197.003 113.43C196.806 113.335 196.595 113.234 196.362 113.133C196.237 113.083 196.128 113.032 195.982 112.982C195.84 112.93 195.698 112.879 195.567 112.841C195.284 112.749 194.891 112.655 194.485 112.628C194.284 112.611 194.08 112.615 193.897 112.629C193.804 112.633 193.709 112.647 193.615 112.659C193.51 112.671 193.466 112.683 193.387 112.696L193.175 112.733C193.112 112.743 193.049 112.756 192.983 112.765C192.851 112.78 192.721 112.8 192.581 112.807C192.31 112.83 192.023 112.829 191.733 112.816L191.513 112.803C191.441 112.796 191.372 112.788 191.299 112.78C191.174 112.772 190.977 112.737 190.812 112.713C190.567 112.674 190.26 112.597 189.985 112.512C189.413 112.343 188.856 112.119 188.274 111.898C187.692 111.677 187.067 111.453 186.323 111.308C185.956 111.237 185.55 111.192 185.178 111.199C184.806 111.205 184.475 111.252 184.209 111.321C184.076 111.355 183.928 111.396 183.837 111.432C183.782 111.454 183.748 111.462 183.675 111.493L183.526 111.559C183.345 111.65 183.199 111.743 183.06 111.821C182.922 111.898 182.773 111.964 182.626 112.007L182.521 112.04C182.482 112.05 182.424 112.056 182.376 112.065C182.334 112.071 182.291 112.078 182.248 112.086C182.199 112.088 182.152 112.092 182.107 112.096C181.92 112.11 181.742 112.121 181.565 112.12C181.39 112.12 181.231 112.126 181.084 112.115C180.934 112.109 180.802 112.103 180.688 112.099C180.568 112.088 180.467 112.079 180.386 112.072C180.229 112.056 180.141 112.048 180.141 112.048Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M172.309 104.382C172.309 104.382 172.393 104.398 172.553 104.429C172.633 104.445 172.73 104.463 172.847 104.486C172.964 104.514 173.098 104.548 173.251 104.588C173.407 104.625 173.57 104.679 173.753 104.735C173.937 104.787 174.128 104.862 174.333 104.944C174.385 104.964 174.438 104.985 174.492 105.005C174.544 105.031 174.594 105.056 174.649 105.082C174.697 105.107 174.744 105.125 174.793 105.155C174.844 105.185 174.899 105.219 174.952 105.25C175.16 105.381 175.309 105.515 175.454 105.653C175.73 105.928 175.974 106.183 176.357 106.424C176.735 106.668 177.195 106.838 177.721 106.923C178.254 107.014 178.826 107.014 179.422 107.018C180.023 107.022 180.649 107.01 181.365 107.068C181.73 107.101 182.093 107.145 182.528 107.246C182.704 107.29 182.849 107.319 183.06 107.381C183.157 107.408 183.258 107.437 183.353 107.465L183.63 107.558C184.369 107.804 185.023 108.175 185.465 108.483C185.87 108.757 186.24 108.894 186.757 108.948C186.825 108.956 186.904 108.967 186.966 108.972L187.145 108.985C187.262 108.997 187.389 108.996 187.51 109.003C187.753 109.012 187.991 109.014 188.22 109.013C188.452 109.015 188.675 109.013 188.898 109.019C188.952 109.021 189.008 109.023 189.062 109.025L189.103 109.026L189.137 109.027L189.157 109.028L189.237 109.035C189.343 109.044 189.44 109.048 189.562 109.067C190.024 109.124 190.399 109.234 190.698 109.332C190.996 109.432 191.212 109.524 191.359 109.586C191.504 109.649 191.582 109.681 191.582 109.681C191.582 109.681 191.5 109.655 191.34 109.606C191.185 109.558 190.953 109.493 190.666 109.418C190.38 109.349 190.018 109.282 189.676 109.263C189.594 109.255 189.493 109.259 189.393 109.258L189.318 109.259L189.3 109.259C189.322 109.26 189.295 109.259 189.295 109.26L189.258 109.262L189.113 109.27C188.916 109.283 188.711 109.297 188.493 109.312C188.276 109.327 188.042 109.343 187.788 109.351C187.654 109.352 187.534 109.359 187.379 109.352C187.228 109.348 187.077 109.342 186.942 109.33C186.645 109.312 186.244 109.254 185.857 109.129C185.664 109.071 185.476 108.992 185.311 108.912C185.226 108.874 185.143 108.825 185.06 108.78C184.966 108.73 184.93 108.702 184.862 108.662L184.678 108.549C184.623 108.516 184.569 108.481 184.512 108.448C184.394 108.386 184.28 108.319 184.153 108.261C183.91 108.14 183.643 108.035 183.368 107.94L183.159 107.871C183.09 107.851 183.021 107.833 182.952 107.814C182.832 107.775 182.636 107.735 182.474 107.697C182.232 107.642 181.918 107.601 181.631 107.578C181.037 107.525 180.436 107.528 179.814 107.519C179.192 107.51 178.528 107.487 177.784 107.348C177.416 107.279 177.022 107.172 176.678 107.028C176.335 106.885 176.045 106.719 175.822 106.557C175.712 106.477 175.589 106.384 175.518 106.317C175.474 106.277 175.446 106.256 175.39 106.201L175.276 106.084C175.141 105.933 175.039 105.793 174.938 105.669C174.839 105.547 174.725 105.43 174.604 105.336L174.518 105.267C174.486 105.244 174.434 105.217 174.393 105.191C174.356 105.168 174.318 105.146 174.281 105.123C174.237 105.103 174.194 105.083 174.154 105.062C173.985 104.981 173.824 104.904 173.659 104.841C173.497 104.776 173.35 104.711 173.21 104.668C173.069 104.618 172.944 104.575 172.836 104.537C172.72 104.502 172.623 104.473 172.545 104.45C172.393 104.407 172.309 104.382 172.309 104.382Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8776 63.1909C21.8776 63.1909 21.9608 63.2119 22.119 63.2504C22.1981 63.2697 22.2942 63.2938 22.4096 63.3222C22.5281 63.3452 22.6641 63.3702 22.8196 63.3985C22.9768 63.43 23.1473 63.4491 23.3367 63.4744C23.5254 63.5044 23.7306 63.5157 23.9514 63.5277C24.0065 63.5312 24.0639 63.534 24.1212 63.5379C24.1794 63.536 24.2353 63.5347 24.2956 63.5342C24.3495 63.5316 24.4003 63.5343 24.457 63.5283C24.5161 63.5216 24.5799 63.5139 24.6411 63.5076C24.8851 63.4756 25.0758 63.4169 25.2653 63.3521C25.6318 63.2176 25.9595 63.0882 26.4087 63.0293C26.8542 62.9659 27.3422 63.0036 27.8566 63.1465C28.3781 63.2868 28.898 63.5255 29.4414 63.7712C29.9888 64.0186 30.5519 64.2911 31.2264 64.5385C31.5728 64.6608 31.921 64.7726 32.3575 64.8632C32.5366 64.8965 32.68 64.9306 32.8972 64.9625C32.997 64.9784 33.101 64.9951 33.1989 65.0087L33.4897 65.0404C34.2637 65.1256 35.0121 65.0626 35.5433 64.9677C36.025 64.8879 36.4186 64.9184 36.911 65.085C36.9763 65.1068 37.0525 65.1296 37.1111 65.1512L37.2785 65.2138C37.3901 65.2513 37.5053 65.3061 37.6181 65.3497C37.8424 65.4434 38.0594 65.5409 38.2676 65.6378C38.4783 65.7332 38.6802 65.8281 38.8855 65.9157C38.9353 65.9368 38.9873 65.9584 39.0371 65.9795L39.0744 65.9956L39.1055 66.0087L39.1244 66.0158L39.1998 66.0433C39.3004 66.0799 39.3898 66.1166 39.5087 66.1504C39.9521 66.2911 40.3389 66.3479 40.6512 66.3842C40.964 66.4176 41.1988 66.4251 41.3583 66.4306C41.5159 66.4338 41.6002 66.4364 41.6002 66.4364C41.6002 66.4364 41.5151 66.4259 41.3496 66.4037C41.1883 66.3832 40.9499 66.3448 40.6582 66.2924C40.3695 66.2357 40.013 66.1459 39.6941 66.0194C39.6164 65.9926 39.5262 65.947 39.4353 65.9061L39.3674 65.8741L39.3509 65.8664C39.3717 65.8748 39.3469 65.8637 39.347 65.8628L39.3144 65.8455L39.1858 65.7777C39.0127 65.6838 38.8317 65.5847 38.6403 65.4808C38.449 65.376 38.2435 65.2639 38.016 65.15C37.8944 65.0932 37.7883 65.037 37.6447 64.9785C37.5059 64.9187 37.3666 64.8609 37.2386 64.8157C36.961 64.708 36.5731 64.5934 36.1695 64.5445C35.9693 64.5165 35.7656 64.5094 35.5822 64.5135C35.4888 64.5123 35.3936 64.5216 35.2989 64.5281C35.193 64.5346 35.1489 64.5448 35.0695 64.5528L34.8557 64.5782C34.7921 64.5851 34.728 64.5948 34.6625 64.6003C34.5297 64.6081 34.3982 64.621 34.2579 64.6207C33.9869 64.6286 33.7001 64.6123 33.4109 64.5839L33.1925 64.5586C33.1207 64.5484 33.0517 64.5357 32.9801 64.5245C32.8557 64.5093 32.6609 64.4636 32.4972 64.431C32.2545 64.3791 31.9521 64.2858 31.682 64.1862C31.1196 63.9862 30.5755 63.7325 30.0066 63.4806C29.4377 63.2286 28.8251 62.9712 28.0909 62.7861C27.7279 62.6952 27.3252 62.6279 26.9531 62.6148C26.5812 62.6007 26.2485 62.6304 25.9785 62.6844C25.8445 62.7116 25.6939 62.7448 25.6018 62.7752C25.545 62.7939 25.5104 62.8008 25.4367 62.8274L25.284 62.8857C25.0983 62.9668 24.9476 63.0518 24.8041 63.1214C24.6627 63.1913 24.51 63.2496 24.3614 63.2841L24.2542 63.3109C24.2149 63.319 24.1565 63.3218 24.1086 63.3283C24.0655 63.3328 24.0224 63.3372 23.9791 63.3426C23.9302 63.3421 23.8832 63.343 23.8383 63.3451C23.6506 63.3485 23.472 63.3506 23.2957 63.3393C23.1212 63.3303 22.9613 63.3276 22.8153 63.3087C22.6663 63.2943 22.5348 63.2818 22.4207 63.2712C22.3012 63.2539 22.2011 63.2399 22.1207 63.2282C21.9646 63.2037 21.8776 63.1909 21.8776 63.1909Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8731 57.5633C14.8731 57.5633 14.9588 57.5681 15.1213 57.5784C15.2026 57.5835 15.3015 57.5891 15.4201 57.5964C15.5401 57.6097 15.6774 57.6264 15.8343 57.6456C15.9937 57.6623 16.1621 57.6949 16.3505 57.7272C16.5395 57.7547 16.7388 57.805 16.9531 57.8593C17.0067 57.8724 17.0624 57.8867 17.1182 57.9001C17.1733 57.9192 17.2263 57.9371 17.2837 57.9556C17.3344 57.9741 17.3836 57.9866 17.436 58.0093C17.4905 58.0332 17.549 58.0596 17.6056 58.0838C17.829 58.187 17.9935 58.2998 18.1552 58.4181C18.465 58.6556 18.7393 58.8767 19.1506 59.0667C19.557 59.2599 20.0341 59.3692 20.5677 59.3859C21.1073 59.4073 21.6748 59.3342 22.2666 59.2614C22.8629 59.1883 23.4816 59.0958 24.1991 59.0604C24.5662 59.0468 24.9319 59.0437 25.3756 59.0872C25.5566 59.1088 25.7036 59.1189 25.9205 59.1531C26.0204 59.1676 26.1247 59.1827 26.2222 59.1988L26.5093 59.2552C27.2735 59.4043 27.9692 59.6872 28.448 59.936C28.8842 60.1556 29.2689 60.2437 29.7886 60.2312C29.8575 60.2298 29.937 60.2309 29.9994 60.2276L30.1779 60.2177C30.2955 60.2151 30.4219 60.1971 30.5425 60.1891C30.7845 60.1664 31.0207 60.138 31.2483 60.1075C31.4779 60.0791 31.6988 60.0487 31.921 60.0261C31.9748 60.0208 32.0308 60.0157 32.0847 60.0103L32.1251 60.0061L32.1587 60.0028L32.1788 60.0016L32.259 59.9979C32.3659 59.9929 32.4622 59.9845 32.5858 59.9876C33.051 59.9853 33.4371 60.0463 33.746 60.1046C34.0546 60.1658 34.281 60.2286 34.4349 60.2708C34.5864 60.3147 34.6675 60.3373 34.6675 60.3373C34.6675 60.3373 34.5832 60.322 34.4186 60.2939C34.2585 60.2654 34.0195 60.2312 33.7254 60.1943C33.4329 60.1625 33.0658 60.1421 32.7238 60.1678C32.6415 60.1703 32.5419 60.187 32.443 60.199L32.3685 60.2093L32.3505 60.2118C32.3729 60.2099 32.3459 60.2131 32.3458 60.214L32.3095 60.2208L32.1665 60.2472C31.9734 60.2853 31.771 60.3261 31.5574 60.3683C31.3436 60.4114 31.114 60.4572 30.8629 60.4982C30.7299 60.5162 30.6119 60.5382 30.4574 60.5514C30.307 60.5671 30.1569 60.5808 30.0212 60.5858C29.7241 60.606 29.3197 60.6 28.9198 60.5264C28.7204 60.4936 28.5238 60.4398 28.3499 60.3812C28.2604 60.3545 28.1723 60.3173 28.0838 60.2829C27.9847 60.2452 27.9457 60.2223 27.8723 60.191L27.6757 60.1031C27.617 60.0776 27.5587 60.0493 27.4978 60.0245C27.3733 59.9775 27.2517 59.926 27.1176 59.8845C26.8613 59.7963 26.5826 59.7265 26.2981 59.6675L26.0821 59.6266C26.0105 59.615 25.9408 59.6066 25.8691 59.5959C25.7459 59.5734 25.5463 59.559 25.3804 59.5414C25.1332 59.5187 24.8167 59.5178 24.5292 59.5324C23.9328 59.5559 23.3378 59.636 22.7197 59.7072C22.1016 59.7783 21.4401 59.8417 20.6841 59.7998C20.3105 59.7784 19.906 59.7228 19.5469 59.6245C19.1877 59.5273 18.8789 59.3998 18.6372 59.2679C18.5174 59.202 18.3835 59.1255 18.3046 59.0691C18.256 59.0343 18.225 59.0174 18.1626 58.97L18.0341 58.8689C17.881 58.7363 17.7625 58.6103 17.6462 58.5011C17.532 58.3922 17.4036 58.2911 17.272 58.2139L17.1777 58.1564C17.1426 58.137 17.0877 58.1169 17.0439 58.0964C17.004 58.0794 16.9642 58.0623 16.9245 58.0443C16.8776 58.0301 16.8331 58.0153 16.7908 57.9999C16.6126 57.9407 16.4427 57.8856 16.2711 57.8439C16.1019 57.8006 15.9484 57.7555 15.8034 57.73C15.6568 57.6995 15.5275 57.6723 15.4155 57.6484C15.2963 57.6293 15.1966 57.6129 15.1163 57.6001C14.96 57.577 14.8731 57.5633 14.8731 57.5633Z"
        fill="#6ACBDD"
      />
      <g filter="url(#filter0_d_2386_93011)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.3185 39.7297C36.6758 35.0698 27.5785 33.0548 22.0264 33.6848C16.8648 34.2704 12.4222 36.0145 6.92718 41.1989C6.20253 41.8826 5.86085 42.8328 6.48606 43.6085C10.7421 50.0158 16.8462 55.4553 21.9962 55.6571C27.4742 55.8717 36.3308 55.1637 48.566 53.5331L49.3185 39.7297Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.3999 37.6527C36.7572 32.9928 27.6598 30.9778 22.1077 31.6078C16.9461 32.1934 11.6178 35.0785 6.12281 40.2629C5.39816 40.9466 5.32142 42.0727 5.94662 42.8484C11.5506 49.8011 16.9275 53.3783 22.0775 53.5801C27.5555 53.7947 36.4121 53.0867 48.6473 51.4561L49.3999 37.6527Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.4298 37.9118C36.7917 33.8576 27.1561 32.0778 21.523 32.5727C16.3616 33.0261 11.364 35.6331 6.53013 40.3936C5.77925 41.1331 5.77003 42.3413 6.50952 43.0922C6.51378 43.0965 6.51806 43.1008 6.52235 43.1051C12.1866 48.7479 17.6016 51.6705 22.7673 51.8728C28.3309 52.0908 37.3278 51.3214 49.7582 49.5647L50.4298 37.9118Z"
          fill="#4E8B7C"
        />
        <path
          opacity="0.31685"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6555 38.9017L17.3693 38.4022C18.0656 38.3085 18.706 38.7971 18.7997 39.4934C18.8094 39.5661 18.8129 39.6395 18.81 39.7128L18.6302 44.3036C18.6027 45.0057 18.0112 45.5525 17.3092 45.525C17.2359 45.5221 17.163 45.5129 17.0913 45.4975L13.4279 44.709C12.8236 44.5789 12.4003 44.0332 12.4245 43.4155L12.5539 40.1127C12.5781 39.495 13.0428 38.9841 13.6555 38.9017Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.9863 38.3379C38.8004 35.3649 32.175 34.1034 28.1103 34.5534C22.0132 35.2284 22.056 50.8064 28.0724 51.0421C32.0834 51.1993 38.5796 50.3883 47.5611 48.6091L47.9863 38.3379Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.1483 34.5068C29.7901 34.4311 27.6134 34.3345 24.6183 34.2172C22.7263 34.143 19.8742 38.1035 19.7657 41.8828C19.6496 45.924 21.9499 49.2026 24.39 50.0772C26.0168 50.6603 28.0595 50.8319 30.5181 50.592C26.3871 49.2479 24.4124 46.2573 24.5941 41.62C24.7758 36.9828 26.9605 34.6118 31.1483 34.5068Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.5059 41.748L51.6599 41.9108L51.47 46.7571L49.7804 46.6909L47.316 46.5943L47.5059 41.748Z"
          fill="#121626"
        />
        <path
          d="M21.5529 46.3938L25.2815 45.6154"
          stroke="#232F3E"
          strokeWidth="0.918048"
          strokeLinecap="square"
        />
        <path
          d="M22.0835 38.925C21.8017 38.6854 22.0327 38.621 22.7767 38.7318C23.5206 38.8426 24.6277 39.1064 26.098 39.523"
          stroke="#232F3E"
          strokeWidth="0.918048"
          strokeLinecap="square"
        />
      </g>
      <g filter="url(#filter1_d_2386_93011)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M168.27 70.651C165.624 73.4166 164.453 75.4427 163.599 76.978C162.775 76.2501 161.464 80.2265 160.116 83.6209C171.208 94.1809 182.347 101.287 192.013 103.296C206.512 106.309 211.307 105.818 212.571 103.543C213.836 101.267 209.789 98.3648 200.951 88.8781C193.768 83.6829 183.836 76.6966 168.27 70.651Z"
          fill="#332F3D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M168.656 69.8893C166.01 72.6549 164.839 74.681 163.985 76.2163C163.161 75.4884 161.85 79.4648 160.502 82.8591C171.594 93.4192 182.734 100.525 192.399 102.534C206.898 105.547 211.693 105.056 212.958 102.781C214.222 100.506 210.175 97.6031 201.337 88.1164C194.155 82.9212 184.222 75.9349 168.656 69.8893Z"
          fill="#E8282F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M168.806 69.8406C166.341 72.2184 164.731 74.0864 163.976 75.4446C163.221 76.8028 162.237 79.2917 161.023 82.9112C172.119 92.706 182.544 98.8264 192.298 101.272C206.929 104.941 212.229 104.282 213.32 102.588C214.411 100.894 210.135 96.2434 200.741 86.9758C194.478 80.7974 183.833 75.0857 168.806 69.8406Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M168.433 72.0154C166.602 73.8011 165.405 75.2019 164.84 76.2178C164.275 77.2338 163.534 79.0928 162.617 81.7951C168.66 87.0946 175.267 90.6241 182.436 92.3834C193.191 95.0224 195.179 94.9241 196.016 93.4185C196.853 91.913 192.183 88.7413 185.322 81.9012C180.748 77.3411 175.119 74.0459 168.433 72.0154Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M178.468 76.5143L177.654 78.6805L178.301 80.9458L180.789 82.7029L178.767 86.3416L176.067 85.1873L174.505 87.7746L172.733 88.7736C184.279 93.8681 192.601 97.1012 197.698 98.4727C199.797 99.0374 202.786 94.439 200.894 92.7235C196.359 88.6126 188.884 83.2095 178.468 76.5143Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M180.386 78.8008L180.635 79.7181L179.085 82.3068L181.354 83.836L179.906 86.4411L177.503 85.3531L176.252 87.6029L174.56 88.4952C185.096 92.8152 192.602 95.6956 197.077 97.1363C198.919 97.7295 201.12 94.4712 199.364 93.0203C195.158 89.5432 188.831 84.8034 180.386 78.8008Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M195.158 92.2957L170.694 78.6966C170.292 78.473 169.785 78.6178 169.561 79.02C169.559 79.0242 169.557 79.0285 169.554 79.0328C169.333 79.448 169.485 79.9641 169.896 80.1928L194.36 93.7919C194.762 94.0154 195.269 93.8707 195.493 93.4685C195.495 93.4643 195.497 93.46 195.5 93.4557C195.721 93.0404 195.569 92.5244 195.158 92.2957Z"
          fill="#ECECEC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M197.518 92.6599L196.326 91.9974C195.837 91.7254 195.22 91.9016 194.948 92.391L194.285 93.5829C194.013 94.0723 194.189 94.6895 194.679 94.9615L195.871 95.6239C196.36 95.8959 196.977 95.7197 197.249 95.2304L197.912 94.0384C198.184 93.5491 198.007 92.9318 197.518 92.6599Z"
          fill="#ECECEC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M166.071 74.7243L164.879 74.0618C164.39 73.7898 163.772 73.9661 163.5 74.4554L162.289 76.6354C162.017 77.1248 162.193 77.742 162.682 78.014L163.874 78.6764C164.364 78.9484 164.981 78.7722 165.253 78.2828L166.464 76.1029C166.736 75.6135 166.56 74.9963 166.071 74.7243Z"
          fill="#232F3E"
        />
      </g>
      <rect
        x="69.1542"
        y="28.5273"
        width="84.7993"
        height="80.8915"
        rx="4"
        fill="#232F3E"
      />
      <g clipPath="url(#clip0_2386_93011)">
        <rect
          x="68.3726"
          y="26.1836"
          width="83.627"
          height="80.8915"
          rx="4"
          fill="white"
        />
        <rect
          x="68.3726"
          y="41.0332"
          width="83.627"
          height="1.9539"
          fill="#232F3E"
        />
        <mask
          id="mask0_2386_93011"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="82"
          y="46"
          width="56"
          height="56"
        >
          <rect
            x="82.7653"
            y="46.8945"
            width="54.7092"
            height="54.7092"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_2386_93011)">
          <path
            d="M89.034 66.8409C88.5496 66.8409 88.1436 66.6761 87.8159 66.3465C87.4882 66.0169 87.3243 65.6085 87.3243 65.1213C87.3243 64.634 87.4882 64.2289 87.8159 63.906C88.1436 63.5831 88.5496 63.4216 89.034 63.4216H106.131C106.615 63.4216 107.021 63.5864 107.349 63.916C107.676 64.2456 107.84 64.654 107.84 65.1412C107.84 65.6285 107.676 66.0336 107.349 66.3565C107.021 66.6795 106.615 66.8409 106.131 66.8409H89.034ZM89.034 85.0773C88.5496 85.0773 88.1436 84.9125 87.8159 84.583C87.4882 84.2533 87.3243 83.8449 87.3243 83.3577C87.3243 82.8704 87.4882 82.4653 87.8159 82.1424C88.1436 81.8195 88.5496 81.658 89.034 81.658H106.131C106.615 81.658 107.021 81.8228 107.349 82.1524C107.676 82.482 107.84 82.8904 107.84 83.3776C107.84 83.8649 107.676 84.27 107.349 84.5929C107.021 84.9159 106.615 85.0773 106.131 85.0773H89.034ZM119.124 69.9753L113.425 64.2764C113.083 63.9345 112.912 63.5356 112.912 63.0797C112.912 62.6238 113.083 62.2248 113.425 61.8829C113.767 61.541 114.166 61.3795 114.622 61.3985C115.078 61.4175 115.477 61.579 115.819 61.8829L120.321 66.328L129.325 57.3238C129.667 56.9819 130.066 56.8204 130.522 56.8394C130.978 56.8584 131.384 57.0389 131.741 57.3808C132.068 57.7227 132.232 58.1216 132.232 58.5775C132.232 59.0335 132.061 59.4324 131.719 59.7743L121.518 69.9753C121.176 70.3172 120.777 70.4882 120.321 70.4882C119.865 70.4882 119.466 70.3172 119.124 69.9753ZM119.124 88.2117L113.425 82.5128C113.083 82.1709 112.912 81.772 112.912 81.3161C112.912 80.8602 113.083 80.4612 113.425 80.1193C113.767 79.7774 114.166 79.6159 114.622 79.6349C115.078 79.6539 115.477 79.8154 115.819 80.1193L120.321 84.5644L129.325 75.5602C129.667 75.2183 130.066 75.0568 130.522 75.0758C130.978 75.0948 131.384 75.2753 131.741 75.6172C132.068 75.9591 132.232 76.358 132.232 76.814C132.232 77.2699 132.061 77.6688 131.719 78.0107L121.518 88.2117C121.176 88.5536 120.777 88.7246 120.321 88.7246C119.865 88.7246 119.466 88.5536 119.124 88.2117Z"
            fill="#4E8B7C"
          />
        </g>
      </g>
      <g filter="url(#filter2_d_2386_93011)">
        <path
          d="M87.9116 22.6659C87.9116 20.0761 90.0111 17.9766 92.601 17.9766C95.1908 17.9766 97.2903 20.0761 97.2903 22.6659V29.7C97.2903 32.2898 95.1908 34.3893 92.601 34.3893C90.0111 34.3893 87.9116 32.2898 87.9116 29.7V22.6659Z"
          fill="#232F3E"
        />
      </g>
      <g filter="url(#filter3_d_2386_93011)">
        <path
          d="M125.817 22.6659C125.817 20.0761 127.917 17.9766 130.507 17.9766C133.097 17.9766 135.196 20.0761 135.196 22.6659V29.7C135.196 32.2898 133.097 34.3893 130.507 34.3893C127.917 34.3893 125.817 32.2898 125.817 29.7V22.6659Z"
          fill="#232F3E"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2386_93011"
          x="0.524109"
          y="28.4961"
          width="56.1357"
          height="34.1992"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_93011"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_93011"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2386_93011"
          x="155.116"
          y="66.8398"
          width="63.3705"
          height="45.5645"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_93011"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_93011"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_2386_93011"
          x="82.9116"
          y="14.9766"
          width="19.3787"
          height="26.4121"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0666667 0 0 0 0 0.0823529 0 0 0 0 0.14902 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_93011"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_93011"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_2386_93011"
          x="120.817"
          y="14.9766"
          width="19.3787"
          height="26.4121"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0666667 0 0 0 0 0.0823529 0 0 0 0 0.14902 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_93011"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_93011"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2386_93011">
          <rect
            x="68.3726"
            y="26.1836"
            width="83.627"
            height="80.8915"
            rx="4"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const NoBoatsLaunched = () => {
  return (
    <svg
      width="146"
      height="108"
      viewBox="0 0 146 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2386_92110)">
        <g filter="url(#filter0_d_2386_92110)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M126.555 47.6667C115.837 58.5817 109.51 67.0527 107.576 73.0798C105.758 78.7436 106.295 85.6663 109.187 93.8479C109.509 94.761 110.48 95.2744 111.422 95.0302C121.391 92.4457 127.692 88.5155 130.324 83.2397C133.099 77.6785 136.492 68.201 140.504 54.8072L126.555 47.6667Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M127.573 47.2537C117.078 59.4693 110.772 68.5932 108.657 74.6255C106.696 80.2173 107.069 86.6388 109.775 93.89C110.136 94.8557 111.215 95.3451 112.185 94.9833C112.191 94.9811 112.197 94.9788 112.203 94.9766C120.754 91.6909 126.348 87.4055 128.985 82.1205C131.797 76.4841 135.197 66.8593 139.184 53.2458L127.573 47.2537Z"
            fill="#4E8B7C"
          />
          <path
            opacity="0.31685"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M111.912 85.5808L113.115 81.3815C113.305 80.7198 113.997 80.3349 114.66 80.5217C114.734 80.5424 114.805 80.5698 114.874 80.6036L120.104 83.1807C120.722 83.4852 120.974 84.2317 120.666 84.8481C120.632 84.9165 120.592 84.9816 120.546 85.0426L117.91 88.5362C117.548 89.0165 116.894 89.1722 116.355 88.9065L112.557 87.0351C112.018 86.7695 111.747 86.158 111.912 85.5808Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M127.164 49.8633C119.838 57.8649 115.476 64.0468 114.076 68.409C111.978 74.9523 128.254 82.1568 131.266 76.1196C133.274 72.0949 135.414 65.0806 137.687 55.0767L127.164 49.8633Z"
            fill="#121626"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M115.011 65.3252C114.319 66.6564 113.235 68.8013 111.758 71.7599C110.826 73.6287 113.599 78.3087 117.427 80.1467C121.521 82.112 125.927 81.2984 127.929 79.2444C129.263 77.8751 130.364 75.8993 131.231 73.317C127.982 76.8567 124.019 77.4745 119.343 75.1706C114.667 72.8666 113.223 69.5848 115.011 65.3252Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M130.061 51.6836L132.184 47.4285L137.059 49.8306L136.196 51.5613L134.936 54.0856L130.061 51.6836Z"
            fill="#121626"
          />
          <path
            d="M122.957 80.5546L124.032 76.372"
            stroke="#232F3E"
            strokeWidth="0.918048"
            strokeLinecap="square"
          />
          <path
            d="M115.41 76.7069C115.061 76.9057 115.113 76.6402 115.566 75.9103C116.02 75.1803 116.784 74.1328 117.858 72.7679"
            stroke="#232F3E"
            strokeWidth="0.918048"
            strokeLinecap="square"
          />
        </g>
        <g filter="url(#filter1_d_2386_92110)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M74.7385 99.6543C74.7385 99.6543 59.5349 79.1017 59.5349 67.8911C59.5349 56.6806 63.0434 7.16743 63.0434 7.16743C63.0434 7.16743 65.3824 3.43059 74.7385 3.43059C84.0945 3.43059 87.603 7.16743 87.603 7.16743C87.603 7.16743 91.1115 60.4174 89.942 69.7596C88.7725 79.1017 74.7385 99.6543 74.7385 99.6543Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M74.5769 92.8789C74.5769 92.8789 70.1249 86.6594 67.0261 80.117C67.0261 80.117 71.5105 81.4266 74.5713 81.4588C77.562 81.49 82.0085 80.0039 82.0085 80.0039C78.902 86.331 74.5769 92.8789 74.5769 92.8789Z"
            fill="#6ACBDD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M63.6211 63.7403L66.1183 76.3253C66.1183 76.3253 69.8635 77.293 74.8579 77.293C79.8523 77.293 83.5975 76.3253 83.5975 76.3253L86.0947 63.7403C86.0947 63.7403 81.8496 65.5474 74.8579 65.5474C67.865 65.5474 63.6211 63.7403 63.6211 63.7403Z"
            fill="#6ACBDD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M77.2608 28.5028L75.1791 28.5028C69.5713 28.5028 64.9832 32.059 64.9832 36.4056L64.9832 51.771C64.9832 56.1176 69.5713 59.6738 75.1791 59.6738L77.2608 59.6738C82.8686 59.6738 87.4567 56.1176 87.4567 51.771L87.4567 36.4055C87.4567 32.059 82.8686 28.5028 77.2608 28.5028Z"
            fill="#D8EEEF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M75.5387 25.1144C70.4824 25.1144 66.345 28.3619 66.345 32.3307L66.345 51.102C66.345 55.0708 70.4824 58.3184 75.5387 58.3184C80.595 58.3184 84.7324 55.0708 84.7324 51.102L84.7324 32.3307C84.7324 28.3619 80.595 25.1144 75.5387 25.1144Z"
            fill="#FEFEFE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M81.6926 31.2129L70.0674 31.2129C69.1404 31.2129 68.3882 31.7739 68.3882 32.4664L68.3882 51.4441C68.3882 54.4918 71.6961 56.9629 75.7772 56.9629C79.9715 56.9629 83.3706 54.4228 83.3706 51.2905L83.3706 32.4664C83.3706 31.7739 82.6196 31.2129 81.6926 31.2129Z"
            fill="#232F3E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M81.9524 30.5361L69.8076 30.5361C69.0247 30.5361 68.3882 31.0256 68.3882 31.629L68.3882 44.698C68.3882 47.3553 71.184 49.5098 74.6335 49.5098L76.9529 49.5098C80.4972 49.5098 83.3706 47.2955 83.3706 44.5643L83.3706 31.629C83.3706 31.0256 82.7353 30.5361 81.9524 30.5361Z"
            fill="#232F3E"
          />
          <path
            opacity="0.336102"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M82.1419 24.4375L69.6168 24.4375C68.9385 24.4375 68.3882 24.0336 68.3882 23.5358L68.3882 14.854C68.3882 12.6621 70.8097 10.8849 73.7964 10.8849L77.8122 10.8849C80.8825 10.8849 83.3706 12.7109 83.3706 14.9642L83.3706 23.5358C83.3706 24.0336 82.8203 24.4375 82.1419 24.4375Z"
            fill="#232F3E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M71.1123 57.6412L72.4743 57.6412L72.4743 61.707L71.1123 61.707L71.1123 57.6412Z"
            fill="#FEFEFE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.707 54.2527L69.0691 54.2527L69.0691 58.9961L67.707 58.9961L67.707 54.2527Z"
            fill="#FEFEFE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M77.9224 57.6412L79.2844 57.6412L79.2844 61.707L77.9224 61.707L77.9224 57.6412Z"
            fill="#FEFEFE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M81.3274 54.2527L82.6894 54.2527L82.6894 58.9961L81.3274 58.9961L81.3274 54.2527Z"
            fill="#FEFEFE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M69.7502 49.7294C69.7502 50.3567 70.8258 50.8653 72.1526 50.8653L72.8849 50.8653C74.2118 50.8653 75.2872 50.3567 75.2872 49.7294L75.2872 48.4258L69.7502 48.4258L69.7502 49.7294Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M75.7905 49.7294C75.7905 50.3567 76.8394 50.8653 78.1331 50.8653L78.8472 50.8653C80.141 50.8653 81.1898 50.3567 81.1898 49.7294L81.3275 48.4258L75.7905 48.4258L75.7905 49.7294Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M69.7502 47.3677C69.7502 47.0541 70.8258 46.7998 72.1526 46.7998L72.8849 46.7998C74.2118 46.7998 75.2872 47.0541 75.2872 47.3677L75.2872 48.0195L69.7502 48.0195L69.7502 47.3677Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M75.7905 47.3677C75.7905 47.0541 76.8394 46.7998 78.1331 46.7998L78.8472 46.7998C80.141 46.7998 81.1898 47.0541 81.1898 47.3677L81.3275 48.0195L75.7905 48.0195L75.7905 47.3677Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M69.7502 21.9462C69.7502 22.5735 70.8258 23.0821 72.1526 23.0821L72.8849 23.0821C74.2118 23.0821 75.2872 22.5735 75.2872 21.9462L75.2872 20.6426L69.7502 20.6426L69.7502 21.9462Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M75.7905 21.9462C75.7905 22.5735 76.8394 23.0821 78.1331 23.0821L78.8472 23.0821C80.141 23.0821 81.1898 22.5735 81.1898 21.9462L81.3275 20.6426L75.7905 20.6426L75.7905 21.9462Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M69.7502 19.5845C69.7502 19.2709 70.8258 19.0166 72.1526 19.0166L72.8849 19.0166C74.2118 19.0166 75.2872 19.2709 75.2872 19.5845L75.2872 20.2363L69.7502 20.2363L69.7502 19.5845Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M75.7905 19.5845C75.7905 19.2709 76.8394 19.0166 78.1331 19.0166L78.8472 19.0166C80.141 19.0166 81.1898 19.2709 81.1898 19.5845L81.3275 20.2363L75.7905 20.2363L75.7905 19.5845Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M79.5361 30.5352C79.021 30.5352 78.6035 31.5826 78.6035 32.8747L78.6035 33.5879C78.6035 34.8801 79.021 35.9274 79.5361 35.9274L80.6064 35.9274L80.6064 30.5352L79.5361 30.5352Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M79.5361 36.418C79.021 36.418 78.6035 37.4394 78.6035 38.6993L78.6035 39.3948C78.6035 40.6547 79.021 41.6761 79.5361 41.6761L80.6064 41.8102L80.6064 36.418L79.5361 36.418Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M81.6357 30.7793C81.8417 30.7793 82.0087 31.8267 82.0087 33.1188L82.0087 33.832C82.0087 35.1242 81.8417 36.1715 81.6357 36.1715L81.2075 36.1715L81.2075 30.7793L81.6357 30.7793Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M81.6357 36.6621C81.8417 36.6621 82.0087 37.6835 82.0087 38.9434L82.0087 39.6389C82.0087 40.8988 81.8417 41.9202 81.6357 41.9202L81.2075 42.0543L81.2075 36.6621L81.6357 36.6621Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M72.2227 30.5352C72.7378 30.5352 73.1553 31.5826 73.1553 32.8747L73.1553 33.5879C73.1553 34.8801 72.7378 35.9274 72.2227 35.9274L71.1523 35.9274L71.1523 30.5352L72.2227 30.5352Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M72.2227 36.418C72.7378 36.418 73.1553 37.4394 73.1553 38.6993L73.1553 39.3948C73.1553 40.6547 72.7378 41.6761 72.2227 41.6761L71.1523 41.8102L71.1523 36.418L72.2227 36.418Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M70.1231 30.7793C69.9171 30.7793 69.7501 31.8267 69.7501 33.1188L69.7501 33.832C69.7501 35.1242 69.9171 36.1715 70.1231 36.1715L70.5513 36.1715L70.5513 30.7793L70.1231 30.7793Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M70.1231 36.6621C69.9171 36.6621 69.7501 37.6835 69.7501 38.9434L69.7501 39.6389C69.7501 40.8988 69.9171 41.9202 70.1231 41.9202L70.5513 42.0543L70.5513 36.6621L70.1231 36.6621Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter2_d_2386_92110)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.4915 95.8951C40.4915 95.8951 48.3353 84.5306 45.5761 71.7721C42.817 59.0139 24.6803 28.3055 24.6803 28.3055C24.6803 28.3055 20.519 27.7148 14.967 30.0184C9.41511 32.3219 6.49867 34.6904 6.49867 34.6904C6.49867 34.6904 15.4719 71.5182 22.2575 81.4472C29.0434 91.3762 40.8368 94.5027 40.8368 94.5027L40.4915 95.8951Z"
            fill="#232F3E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.022 95.8457C42.022 95.8457 47.2031 85.3523 44.0157 72.371C40.8284 59.3898 22.8669 27.5074 22.8669 27.5074C22.8669 27.5074 19.1089 26.6826 14.2689 28.6908C9.42897 30.6989 6.95172 32.9186 6.95172 32.9186C6.95172 32.9186 17.0552 70.4457 23.6875 80.8054C30.32 91.1651 42.022 95.8457 42.022 95.8457Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.7905 92.0177C40.7905 92.0177 48.2447 80.4344 36.5954 59.9323C36.5954 59.9323 35.1112 61.9334 29.1701 64.3983C23.229 66.8632 20.7524 66.5054 20.7524 66.5054C20.7524 66.5054 22.7351 87.0868 39.4313 92.5816L40.7905 92.0177Z"
            fill="#E8282F"
          />
          <path
            opacity="0.250873"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1344 29.6851C19.1914 28.8317 21.7889 30.3498 22.9358 33.0759L33.6901 55.9897C34.837 58.7157 34.0994 61.6176 32.0422 62.4711L23.1803 66.1479C21.1233 67.0014 18.526 65.4831 17.3791 62.7571L8.7111 38.9777C7.56417 36.2517 8.30181 33.3498 10.3588 32.4964L17.1344 29.6851Z"
            fill="#232F3E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3713 34.9961L9.21007 27.4825L16.1121 24.6189L17.639 28.2479L19.2734 32.1325L12.3713 34.9961Z"
            fill="#121626"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.0972 52.4111L26.656 49.275C28.951 48.3229 31.3377 48.8022 31.987 50.3456L38.5967 63.102C39.2461 64.6453 37.9122 66.6683 35.6174 67.6204L25.731 71.7221C23.4361 72.6743 21.0494 72.1949 20.4 70.6516L16.1179 56.9295C15.4685 55.3862 16.8024 53.3632 19.0972 52.4111Z"
            fill="#232F3E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.9985 59.1414C35.3905 60.0731 34.4379 61.3556 32.8708 62.0058L32.0058 62.3646C30.4386 63.0149 28.8505 62.7865 28.4585 61.8548L27.6438 59.9185L34.1838 57.2051L34.9985 59.1414Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.0923 62.0067C28.4843 62.9384 27.4944 64.2363 25.8814 64.9056L24.991 65.275C23.378 65.9442 21.7525 65.7314 21.3605 64.7996L20.3742 62.9345L27.2776 60.0703L28.0923 62.0067Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.654 55.9439C33.4797 55.5297 32.0678 55.7212 30.5004 56.3715L29.6353 56.7305C28.0677 57.3809 26.9385 58.2438 27.1128 58.658L27.4749 59.5187L34.0161 56.8047L33.654 55.9439Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.748 58.8091C26.5737 58.395 25.1246 58.6018 23.5112 59.2712L22.6207 59.6407C21.0074 60.3101 19.8408 61.1886 20.015 61.6028L20.2055 62.5348L27.1101 59.6699L26.748 58.8091Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.6161 64.3343C39.6161 64.3343 39.8065 68.3633 32.0266 70.8207L29.4515 64.7002C29.4515 64.7002 34.0272 62.8018 35.3054 60.7308L39.6161 64.3343Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.3377 71.7017C21.3377 71.7017 24.0903 74.6677 31.3183 70.8986L28.7432 64.778C28.7432 64.778 24.1675 66.6764 21.7855 66.124L21.3377 71.7017Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.1448 70.7153L30.5177 70.9755L36.5728 85.3696L37.2 85.1094L31.1448 70.7153Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_2386_92110"
          x="101.524"
          y="44.2539"
          width="43.9802"
          height="57.8477"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_92110"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_92110"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2386_92110"
          x="54.5349"
          y="0.429688"
          width="40.6458"
          height="106.225"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_92110"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_92110"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_2386_92110"
          x="1.49878"
          y="21.6191"
          width="49.6655"
          height="81.2754"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_92110"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_92110"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2386_92110">
          <rect
            width="145.07"
            height="107"
            fill="white"
            transform="translate(145.535 107.432) rotate(180)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const NoLaunchesScheduled = () => {
  return (
    <svg
      width="83"
      height="49"
      viewBox="0 0 83 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.151578"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.3202 28.3777C72.0873 34.7554 66.0967 35.3242 56.9381 30.9475C47.7794 26.5709 50.273 16.7994 55.5059 10.4218C59.3907 5.68704 64.5109 2.22749 69.554 7.36269C70.5598 8.38689 70.838 9.79872 71.0898 11.2839L71.1265 11.5017C71.1327 11.5381 71.1388 11.5745 71.1449 11.611L71.182 11.83L71.22 12.0495C71.5538 13.9532 72.0378 15.8887 74.1024 17.2146C77.5433 19.4244 82.5531 22 77.3202 28.3777Z"
        fill="#6ACBDD"
      />
      <path
        opacity="0.151578"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0631 2.88784C32.0909 1.31937 46.9378 8.0556 57.4808 21.2202C62.0834 36.1356 39.5437 45.4054 26.5159 46.9739C16.8442 48.1383 2.04274 46.5125 2.70012 35.2021C2.83765 32.8363 4.32467 30.8545 5.8773 28.791L6.09424 28.5025C8.08441 25.852 10.0842 23.0322 9.40707 19.068C8.34017 12.8215 6.03531 4.45633 19.0631 2.88784Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.7433 39.4741C64.7433 39.4741 64.6926 39.506 64.5969 39.5674C64.549 39.5981 64.4905 39.635 64.4206 39.6797C64.3518 39.7285 64.2736 39.7852 64.1843 39.8501C64.0926 39.9143 64.0008 39.9913 63.8967 40.0748C63.7907 40.1557 63.686 40.254 63.5736 40.3598C63.5452 40.386 63.5161 40.4136 63.4866 40.4407C63.4594 40.471 63.4331 40.4999 63.4044 40.5306C63.3797 40.5591 63.3538 40.5835 63.3295 40.6151C63.3044 40.6481 63.2776 40.6841 63.2513 40.7181C63.1498 40.8568 63.0876 40.9814 63.029 41.1084C62.9203 41.3585 62.8277 41.5865 62.641 41.8419C62.4583 42.0976 62.204 42.3261 61.8839 42.5171C61.5616 42.7131 61.1903 42.8608 60.8043 43.017C60.4154 43.1744 60.0062 43.3276 59.5561 43.5493C59.3274 43.6654 59.103 43.7874 58.8468 43.9644C58.7436 44.0389 58.6573 44.0949 58.5365 44.1893C58.4804 44.232 58.4218 44.2766 58.3677 44.3195L58.2115 44.4512C57.7954 44.8013 57.4665 45.2099 57.2584 45.5241C57.0665 45.806 56.8615 45.9902 56.5399 46.1587C56.4974 46.1812 56.4492 46.2088 56.41 46.228L56.2977 46.2824C56.2249 46.3207 56.1417 46.3525 56.0653 46.3885C55.9098 46.4567 55.756 46.5194 55.6066 46.5779C55.4569 46.6384 55.3116 46.6947 55.1684 46.7562C55.1337 46.7712 55.0977 46.7871 55.063 46.8021L55.0369 46.8132L55.0153 46.8226L55.0026 46.8287L54.9524 46.8536C54.8854 46.8867 54.8238 46.9143 54.7494 46.958C54.4645 47.1143 54.2494 47.2824 54.0806 47.4228C53.9129 47.5647 53.7959 47.6798 53.7162 47.7577C53.6386 47.8358 53.5967 47.8772 53.5967 47.8772C53.5967 47.8772 53.6431 47.8393 53.734 47.7663C53.8221 47.6947 53.9565 47.5927 54.1235 47.4705C54.2914 47.352 54.5086 47.2151 54.7262 47.1149C54.7772 47.0885 54.8437 47.065 54.9082 47.0387L54.9572 47.0198L54.969 47.0152C54.9547 47.0216 54.9722 47.0144 54.9727 47.015L54.9971 47.0068L55.0933 46.9745C55.2242 46.9323 55.3616 46.8886 55.5064 46.8419C55.6515 46.7958 55.8072 46.7459 55.9745 46.6859C56.0618 46.6518 56.1413 46.6252 56.2401 46.5809C56.3372 46.5395 56.4336 46.497 56.5181 46.4541C56.7064 46.3657 56.9512 46.225 57.1705 46.0445C57.2811 45.9569 57.3829 45.8573 57.4693 45.7626C57.5148 45.716 57.556 45.6634 57.5984 45.6124C57.6461 45.5558 57.6623 45.5286 57.6965 45.4846L57.7867 45.3643C57.8139 45.3289 57.8399 45.2918 57.8687 45.256C57.9288 45.1851 57.9856 45.1124 58.0534 45.0417C58.18 44.9009 58.3265 44.7638 58.4802 44.6314L58.5983 44.5332C58.638 44.5019 58.6777 44.4731 58.7179 44.4423C58.7855 44.3867 58.9025 44.3103 58.9979 44.2433C59.1411 44.1457 59.334 44.0378 59.5146 43.9493C59.8867 43.7615 60.2772 43.6088 60.6787 43.4427C61.0803 43.2767 61.5056 43.0911 61.9531 42.8093C62.174 42.6696 62.4021 42.4985 62.5881 42.3168C62.7744 42.1357 62.9198 41.9532 63.0226 41.7907C63.0735 41.7099 63.1293 41.6178 63.1584 41.5566C63.1762 41.5189 63.1895 41.4981 63.2115 41.448L63.2557 41.3427C63.3042 41.2098 63.3339 41.0927 63.3679 40.9866C63.4007 40.8814 63.4449 40.7761 63.499 40.6844L63.5371 40.6173C63.552 40.5936 63.5787 40.5627 63.5985 40.5353C63.6171 40.5114 63.6356 40.4875 63.6537 40.463C63.6776 40.4385 63.6997 40.4144 63.7203 40.3906C63.8091 40.2941 63.8941 40.2029 63.9848 40.1192C64.0735 40.0354 64.1519 39.9558 64.2318 39.8912C64.311 39.8228 64.3807 39.7624 64.4409 39.7098C64.5073 39.6578 64.5626 39.614 64.6073 39.579C64.6949 39.5119 64.7433 39.4741 64.7433 39.4741Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.2012 1.80544C53.2012 1.80544 53.2473 1.8437 53.3354 1.91561C53.3795 1.95157 53.4327 1.99568 53.4969 2.04829C53.5647 2.09848 53.6429 2.15519 53.7323 2.21985C53.8219 2.28703 53.9236 2.35038 54.0354 2.42333C54.1452 2.49903 54.2711 2.56794 54.4066 2.64194C54.4403 2.66071 54.4756 2.67982 54.5106 2.69947C54.5478 2.71583 54.5835 2.73186 54.6216 2.74965C54.6564 2.76425 54.6875 2.78125 54.7251 2.79453C54.7643 2.80815 54.8069 2.82243 54.8473 2.83692C55.0107 2.89018 55.1485 2.91061 55.2875 2.92685C55.5589 2.9524 55.8044 2.96954 56.1052 3.06763C56.405 3.16177 56.7012 3.33246 56.9823 3.57737C57.2688 3.82273 57.5245 4.12974 57.793 4.44812C58.0635 4.76882 58.3363 5.11007 58.6869 5.46898C58.8683 5.65032 59.0541 5.82563 59.3019 6.01414C59.4047 6.08905 59.4848 6.15368 59.6121 6.2392C59.6702 6.27926 59.7307 6.32108 59.7883 6.35915L59.962 6.46666C60.4241 6.75332 60.9147 6.93895 61.278 7.03904C61.6056 7.13379 61.8444 7.27147 62.1046 7.5247C62.1392 7.55811 62.1804 7.59538 62.2108 7.62668L62.2974 7.71652C62.3564 7.77373 62.4126 7.84293 62.4705 7.90433C62.5837 8.03097 62.6911 8.15769 62.7931 8.28145C62.8972 8.40499 62.9958 8.52554 63.0988 8.64259C63.1238 8.67091 63.1501 8.70012 63.1751 8.72844L63.1938 8.74982L63.2095 8.76746L63.2192 8.7776L63.2585 8.81761C63.3108 8.87096 63.3561 8.921 63.4209 8.97812C63.658 9.20028 63.8846 9.35245 64.0705 9.46934C64.2575 9.58458 64.4033 9.66002 64.5021 9.71149C64.6004 9.76098 64.6528 9.78793 64.6528 9.78793C64.6528 9.78793 64.6023 9.7557 64.5047 9.69191C64.4092 9.63044 64.2706 9.53444 64.1025 9.41363C63.9377 9.29096 63.74 9.12707 63.5771 8.95139C63.5362 8.91104 63.4932 8.85518 63.4482 8.80207L63.415 8.7614L63.4069 8.7516C63.4175 8.76317 63.4052 8.74873 63.4056 8.74818L63.3902 8.72747L63.3296 8.64605C63.2488 8.53478 63.1645 8.41778 63.0752 8.29471C62.9862 8.1711 62.8905 8.03856 62.7814 7.8983C62.7219 7.8259 62.6719 7.75858 62.5991 7.67846C62.5295 7.599 62.4592 7.52064 62.3921 7.45361C62.2496 7.30217 62.0397 7.11317 61.8 6.96087C61.6824 6.88296 61.5561 6.81713 61.4393 6.76451C61.3808 6.73568 61.318 6.71288 61.2563 6.68844C61.1877 6.66068 61.1568 6.6538 61.1044 6.63499L60.962 6.58661C60.9199 6.57178 60.8766 6.5586 60.8336 6.54234C60.7475 6.50728 60.6608 6.47586 60.5724 6.43343C60.3993 6.35683 60.2235 6.2602 60.0498 6.15522L59.9198 6.07354C59.8777 6.04551 59.8379 6.01672 59.7962 5.98814C59.7224 5.94112 59.6134 5.85366 59.5201 5.78383C59.3827 5.67804 59.2203 5.52821 59.08 5.38414C58.7858 5.08881 58.5193 4.76518 58.2367 4.43512C57.954 4.10507 57.6455 3.75844 57.2385 3.42076C57.0371 3.25423 56.8036 3.0906 56.5731 2.97031C56.343 2.84948 56.1244 2.76804 55.9379 2.72079C55.8453 2.6976 55.7404 2.67318 55.6732 2.66457C55.6318 2.65931 55.6079 2.65321 55.5535 2.64781L55.4397 2.63855C55.2983 2.63374 55.1777 2.64195 55.0663 2.64259C54.9562 2.64412 54.8424 2.63485 54.7384 2.61186L54.6627 2.59652C54.6356 2.58975 54.5979 2.57394 54.5657 2.56364C54.5372 2.55346 54.5087 2.54328 54.4799 2.53365C54.4492 2.51862 54.4193 2.50503 54.3904 2.49287C54.271 2.43849 54.1579 2.386 54.0502 2.32582C53.9429 2.26763 53.8429 2.2178 53.7566 2.16196C53.6671 2.10797 53.588 2.0605 53.5193 2.01955C53.4492 1.97265 53.3903 1.93369 53.3432 1.90213C53.2522 1.83967 53.2012 1.80544 53.2012 1.80544Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.6906 47.2619C42.6906 47.2619 42.7812 47.1884 42.9541 47.0504C43.0405 46.9813 43.1451 46.8966 43.271 46.7956C43.4039 46.6994 43.5572 46.5907 43.7327 46.4668C43.9083 46.338 44.1074 46.2168 44.3264 46.0773C44.5417 45.9323 44.7881 45.8009 45.0533 45.6597C45.1192 45.6239 45.1884 45.5875 45.2567 45.55C45.3296 45.5189 45.3992 45.4885 45.4738 45.4547C45.5417 45.427 45.6027 45.3946 45.6761 45.3695C45.7527 45.3439 45.8357 45.317 45.9148 45.2896C46.2338 45.1894 46.5023 45.1526 46.7729 45.1239C47.3016 45.0799 47.7795 45.0517 48.3667 44.8671C48.952 44.6903 49.5319 44.3644 50.0839 43.8938C50.6463 43.4225 51.1503 42.8305 51.6792 42.2167C52.2122 41.5985 52.7501 40.9403 53.4396 40.2494C53.7965 39.9004 54.1615 39.5632 54.6476 39.2017C54.8493 39.0581 55.0064 38.934 55.2559 38.7703C55.3696 38.6936 55.4883 38.6135 55.6011 38.5406L55.9414 38.3351C56.8463 37.7871 57.8047 37.4362 58.5136 37.2491C59.1529 37.0716 59.6204 36.8088 60.1318 36.3216C60.1998 36.2573 60.2808 36.1857 60.3406 36.1254L60.511 35.9524C60.627 35.8423 60.7377 35.7089 60.8517 35.5907C61.0745 35.3467 61.2861 35.1024 61.4872 34.8637C61.6922 34.6256 61.8866 34.3931 62.0895 34.1675C62.1388 34.113 62.1905 34.0567 62.2398 34.0021L62.2765 33.9609L62.3074 33.9269L62.3265 33.9074L62.4037 33.8304C62.5067 33.7277 62.5959 33.6313 62.7231 33.5215C63.189 33.0943 63.6331 32.803 63.9971 32.5795C64.3635 32.3592 64.6486 32.2155 64.8419 32.1174C65.0343 32.0232 65.1367 31.9718 65.1367 31.9718C65.1367 31.9718 65.0379 32.0335 64.8466 32.1555C64.6596 32.2731 64.3878 32.457 64.0583 32.6885C63.735 32.9237 63.3471 33.2384 63.0266 33.5768C62.9461 33.6544 62.8612 33.7622 62.7725 33.8646L62.7071 33.943L62.6912 33.9619C62.712 33.9396 62.6878 33.9675 62.6885 33.9685L62.6582 34.0085L62.5385 34.1656C62.379 34.3804 62.2127 34.6063 62.0363 34.8438C61.8606 35.0825 61.6715 35.3383 61.4564 35.6089C61.339 35.7485 61.2404 35.8784 61.0971 36.0328C60.9601 36.1859 60.8216 36.3369 60.6897 36.4659C60.4093 36.7575 59.997 37.1208 59.5275 37.4121C59.2969 37.5612 59.05 37.6867 58.8215 37.7866C58.7071 37.8414 58.5845 37.8845 58.4641 37.9307C58.3299 37.9833 58.2698 37.9961 58.1673 38.0316L57.8893 38.1227C57.807 38.1507 57.7225 38.1754 57.6385 38.2061C57.4704 38.2725 57.301 38.3318 57.1282 38.4125C56.7898 38.5579 56.4457 38.7422 56.1056 38.9429L55.851 39.099C55.7684 39.1527 55.6905 39.2079 55.6087 39.2626C55.4641 39.3525 55.2503 39.5204 55.0673 39.6543C54.7978 39.8572 54.4786 40.1453 54.2028 40.4227C53.6242 40.9911 53.099 41.6151 52.5421 42.2513C51.9853 42.8875 51.3778 43.5554 50.579 44.2039C50.1837 44.5236 49.7259 44.8371 49.275 45.0663C48.8248 45.2965 48.3978 45.4504 48.0341 45.5384C47.8534 45.5816 47.6489 45.6269 47.5179 45.6422C47.4372 45.6516 47.3907 45.663 47.2846 45.6723L47.063 45.688C46.7879 45.6944 46.5535 45.6759 46.3367 45.6723C46.1225 45.667 45.9009 45.6826 45.698 45.7252L45.5506 45.7535C45.4976 45.7661 45.424 45.796 45.3612 45.8154C45.3056 45.8346 45.2499 45.8538 45.1935 45.8719C45.1335 45.9005 45.0751 45.9264 45.0185 45.9494C44.7852 46.0527 44.564 46.1525 44.3532 46.2673C44.1434 46.3783 43.9478 46.4731 43.7787 46.5799C43.6034 46.6831 43.4485 46.7738 43.314 46.852C43.1766 46.9418 43.0613 47.0164 42.9689 47.0768C42.7905 47.1964 42.6906 47.2619 42.6906 47.2619Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.5182 18.021C65.5182 18.021 65.4202 17.9578 65.2353 17.8364C65.1428 17.7757 65.0298 17.7026 64.8946 17.6143C64.7618 17.5179 64.6109 17.406 64.4386 17.2778C64.2616 17.1509 64.0845 16.9993 63.8838 16.8345C63.6791 16.675 63.4776 16.4816 63.261 16.2734C63.2065 16.2219 63.1504 16.1675 63.0935 16.1142C63.0413 16.0546 62.9907 15.9978 62.9354 15.9375C62.888 15.8815 62.8382 15.8336 62.7916 15.7716C62.7434 15.7068 62.692 15.6363 62.6415 15.5696C62.4471 15.2976 62.3286 15.0538 62.2172 14.8055C62.011 14.3167 61.8357 13.8712 61.4778 13.3705C61.1277 12.8691 60.6377 12.4193 60.0189 12.0409C59.3961 11.6529 58.6768 11.3578 57.929 11.0459C57.1757 10.7314 56.3829 10.4248 55.5119 9.98417C55.0693 9.7535 54.6354 9.51131 54.1407 9.16173C53.9415 9.01465 53.7747 8.90385 53.5416 8.71764C53.4333 8.63335 53.3203 8.54543 53.216 8.46086L52.9149 8.20134C52.1127 7.51156 51.4813 6.70972 51.0831 6.09413C50.7157 5.54161 50.3206 5.179 49.6985 4.84433C49.6163 4.79973 49.5231 4.74503 49.4472 4.7069L49.2298 4.5987C49.0891 4.52264 48.9279 4.45892 48.7801 4.38733C48.4789 4.25145 48.181 4.12623 47.8916 4.00927C47.6016 3.88843 47.3202 3.77588 47.0427 3.65314C46.9755 3.62329 46.906 3.59164 46.8388 3.56179L46.7882 3.53967L46.7463 3.52088L46.7218 3.50878L46.6246 3.4593C46.495 3.39334 46.3756 3.33851 46.2318 3.2518C45.6809 2.94178 45.266 2.61024 44.9404 2.33367C44.6171 2.05397 44.3919 1.82763 44.2386 1.67433C44.0892 1.52076 44.0086 1.43944 44.0086 1.43944C44.0086 1.43944 44.0979 1.5142 44.2734 1.65802C44.4433 1.79926 44.7025 2.00043 45.025 2.24162C45.349 2.47577 45.7687 2.74665 46.19 2.94617C46.2888 2.9985 46.4176 3.04573 46.5425 3.09818L46.6373 3.13596L46.6603 3.14521C46.6326 3.13234 46.6666 3.14674 46.6674 3.14569L46.7148 3.16211L46.9013 3.227C47.1551 3.31184 47.4215 3.39975 47.7021 3.49357C47.9835 3.58635 48.2854 3.68656 48.6095 3.80695C48.7786 3.87506 48.9328 3.9284 49.1241 4.01669C49.3122 4.09927 49.4987 4.18395 49.6623 4.26926C50.0267 4.44515 50.5001 4.72409 50.9229 5.07978C51.1363 5.25256 51.3323 5.44832 51.4983 5.63437C51.586 5.72606 51.665 5.82925 51.7464 5.9293C51.8381 6.04049 51.8689 6.09369 51.9345 6.18003L52.1075 6.416C52.1597 6.48549 52.2094 6.55812 52.2648 6.62837C52.3801 6.76755 52.4892 6.91015 52.6196 7.04925C52.863 7.32572 53.1451 7.59548 53.4414 7.85633L53.6691 8.04985C53.7457 8.11166 53.8224 8.16853 53.8998 8.22929C54.0302 8.33873 54.2563 8.48982 54.4404 8.62214C54.717 8.81515 55.0901 9.02901 55.4394 9.20498C56.1595 9.57817 56.9159 9.88346 57.6937 10.215C58.4714 10.5464 59.2951 10.9162 60.1597 11.474C60.5865 11.7503 61.0267 12.0879 61.3847 12.4453C61.7435 12.8016 62.0225 13.1597 62.2192 13.478C62.3164 13.6363 62.423 13.8166 62.4783 13.9363C62.5123 14.0101 62.5376 14.0508 62.5794 14.1487L62.6632 14.3544C62.7548 14.614 62.81 14.8425 62.874 15.0496C62.9356 15.2549 63.0193 15.4607 63.1228 15.6402L63.1955 15.7716C63.224 15.818 63.2753 15.8787 63.3132 15.9324C63.3488 15.9793 63.3844 16.0262 63.4191 16.0742C63.465 16.1224 63.5076 16.1698 63.5471 16.2164C63.7178 16.4061 63.8814 16.5853 64.0561 16.75C64.2268 16.9149 64.3777 17.0713 64.5318 17.1989C64.6843 17.3334 64.8187 17.4525 64.9349 17.556C65.0629 17.6587 65.1696 17.7451 65.2557 17.8141C65.4249 17.9465 65.5182 18.021 65.5182 18.021Z"
        fill="#6ACBDD"
      />
      <g filter="url(#filter0_d_2386_93148)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.59827 18.2249C23.6056 14.6711 35.9313 13.0899 42.8228 13.9538C49.2297 14.7569 53.3636 15.4017 60.022 21.3464C60.9001 22.1304 62.7533 22.7487 61.9472 23.5962C56.4193 30.623 48.6243 36.5164 42.204 36.5924C35.3746 36.6732 23.0457 35.2643 7.86727 33.0901L7.59827 18.2249Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75319 18.7364C23.4967 15.8064 34.9483 12.3885 41.8398 13.2523C48.2467 14.0554 54.5354 15.7721 61.1938 21.7169C62.0719 22.5008 62.3422 22.9353 62.3147 23.9424C55.3771 30.6752 48.56 35.5468 42.1396 35.6227C35.3103 35.7035 23.0733 34.2528 7.89495 32.0786L7.75319 18.7364Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.37176 17.9921C24.4993 13.8629 36.5617 12.156 43.559 12.8714C49.9704 13.5269 56.1011 16.581 61.9513 22.0335C62.86 22.8805 62.8285 24.2291 61.8809 25.0456C61.8755 25.0503 61.87 25.055 61.8645 25.0596C54.6101 31.1925 47.7629 34.2971 41.3229 34.3733C34.3869 34.4553 23.2105 33.336 7.79357 31.0154L7.37176 17.9921Z"
          fill="#4E8B7C"
        />
        <path
          opacity="0.31685"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.1312 20.1607L48.5242 19.4956C47.6604 19.3709 46.8455 19.8976 46.7041 20.6719C46.6893 20.7527 46.6824 20.8346 46.6834 20.9164L46.744 26.0448C46.7533 26.829 47.4703 27.4564 48.3456 27.446C48.4369 27.445 48.5281 27.4368 48.6179 27.4217L53.2079 26.6478C53.9651 26.5202 54.5117 25.9235 54.5035 25.2335L54.4599 21.544C54.4517 20.854 53.8912 20.2704 53.1312 20.1607Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3995 18.5373C21.9444 15.4858 30.2398 14.27 35.2855 14.89C42.8542 15.8199 42.2467 33.2029 34.7461 33.2916C29.7457 33.3507 21.6849 32.2575 10.5636 30.0118L10.3995 18.5373Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.504 14.7499C33.198 14.7047 35.912 14.66 39.646 14.6159C42.0047 14.588 45.4154 19.0902 45.4162 23.3109C45.4169 27.824 42.4358 31.416 39.366 32.3214C37.3195 32.925 34.7696 33.0573 31.7165 32.7184C36.9086 31.3381 39.474 28.0579 39.4127 22.8778C39.3515 17.6976 36.7152 14.9883 31.504 14.7499Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8763 22.3574L5.69761 22.4187L5.76165 27.8324L7.868 27.8074L10.9403 27.7711L10.8763 22.3574Z"
          fill="#121626"
        />
        <path
          d="M43.03 28.2948L38.4145 27.3181"
          stroke="#232F3E"
          strokeWidth="0.918048"
          strokeLinecap="square"
        />
        <path
          d="M42.6349 19.9437C42.9944 19.6845 42.709 19.6059 41.7786 19.708C40.8483 19.8101 39.4602 20.0724 37.6144 20.4948"
          stroke="#232F3E"
          strokeWidth="0.918048"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2386_93148"
          x="0.697632"
          y="9.71289"
          width="66.9151"
          height="33.8828"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_93148"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_93148"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export const NoRecentReturns = () => {
  return (
    <svg
      width="182"
      height="126"
      viewBox="0 0 182 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2386_92178)">
        <path
          opacity="0.151578"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7626 74.8972C27.6698 57.7063 41.6601 54.0001 65.1125 60.7817C88.565 67.5632 86.4925 91.7291 76.5853 108.92C69.2303 121.682 58.4426 131.905 44.4566 121.705C41.6672 119.67 40.4517 116.43 39.27 113.005L39.0971 112.503C39.0683 112.419 39.0394 112.335 39.0105 112.251L38.8364 111.746L38.66 111.24C37.119 106.854 35.2093 102.452 29.7889 100.118C20.7554 96.2287 7.85543 92.0881 17.7626 74.8972ZM78.5697 19.1406C94.6238 -1.43577 113.521 -3.7074 142.816 9.40556C172.111 22.5184 164.98 53.6078 148.926 74.1842C137.007 89.46 121.085 100.802 104.744 84.9656C101.326 81.653 100.406 76.9292 99.453 72.0043L99.3197 71.3159C98.0905 64.9961 96.6165 58.4395 89.6038 54.1784C78.5541 47.4641 62.5157 39.717 78.5697 19.1406Z"
          fill="#6ACBDD"
        />
        <path
          d="M115.021 12.7559C109.323 9.95009 103.115 8.14984 96.6787 7.51781C90.4703 6.9082 84.049 7.38536 77.6675 9.09526C72.3092 10.531 67.361 12.7336 62.9095 15.5532C46.6621 25.8445 37.0308 44.3565 38.2174 63.811"
          stroke="#232F3E"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M111.671 4.9375L115.372 12.9575L107.969 18.5107"
          stroke="#232F3E"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M64.6984 106.392C70.241 109.492 76.3461 111.615 82.741 112.583C88.909 113.516 95.3465 113.376 101.809 112.002C107.235 110.849 112.291 108.908 116.884 106.326C136.682 95.1924 147.865 72.1263 142.894 48.7369"
          stroke="#232F3E"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M65.9337 115.055L64.4186 106.198L73.1373 102.682"
          stroke="#232F3E"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M145.057 32.3902C145.057 32.3902 145.212 32.4021 145.507 32.4225C145.654 32.4326 145.833 32.4463 146.048 32.4616C146.267 32.4663 146.518 32.4693 146.805 32.4722C147.095 32.4803 147.406 32.4622 147.752 32.4492C148.099 32.445 148.469 32.4022 148.868 32.3558C148.967 32.3451 149.071 32.3327 149.174 32.3219C149.278 32.3007 149.377 32.2813 149.485 32.2618C149.581 32.2406 149.672 32.2299 149.772 32.2017C149.875 32.1717 149.987 32.1382 150.095 32.1083C150.521 31.9761 150.844 31.8127 151.163 31.6388C151.777 31.2858 152.323 30.9539 153.108 30.7108C153.885 30.4607 154.769 30.3783 155.732 30.476C156.708 30.5667 157.711 30.834 158.757 31.1065C159.812 31.3808 160.903 31.6952 162.184 31.9304C162.841 32.0428 163.498 32.1359 164.306 32.1639C164.637 32.1685 164.903 32.1854 165.301 32.1758C165.485 32.1737 165.676 32.1715 165.855 32.1659L166.385 32.1333C167.794 32.048 169.113 31.7058 170.034 31.3731C170.871 31.0826 171.583 31.0164 172.515 31.1631C172.638 31.1821 172.782 31.1993 172.893 31.2201L173.211 31.2806C173.422 31.3134 173.645 31.376 173.86 31.4193C174.29 31.5181 174.708 31.6257 175.11 31.7351C175.516 31.841 175.906 31.9486 176.3 32.0423C176.395 32.0648 176.495 32.0874 176.59 32.1099L176.662 32.1272L176.722 32.1411L176.758 32.148L176.901 32.174C177.092 32.2086 177.263 32.2467 177.486 32.2707C178.322 32.3862 179.031 32.369 179.6 32.338C180.17 32.3018 180.592 32.2432 180.879 32.2041C181.162 32.1615 181.313 32.1401 181.313 32.1401C181.313 32.1401 181.158 32.1475 180.855 32.1586C180.56 32.1715 180.122 32.1759 179.585 32.1718C179.051 32.1589 178.386 32.1078 177.777 31.9797C177.63 31.9555 177.455 31.9016 177.28 31.8565L177.149 31.82L177.117 31.8113C177.157 31.82 177.109 31.8078 177.109 31.8061L177.045 31.7852L176.794 31.7035C176.456 31.5888 176.102 31.467 175.728 31.3401C175.354 31.2114 174.952 31.074 174.51 30.9402C174.276 30.8759 174.069 30.8081 173.794 30.7475C173.527 30.6833 173.261 30.6226 173.018 30.5811C172.489 30.4738 171.76 30.3878 171.023 30.4244C170.657 30.4357 170.291 30.4854 169.964 30.5491C169.797 30.5757 169.629 30.6216 169.462 30.6622C169.275 30.7063 169.199 30.738 169.059 30.7768L168.685 30.8878C168.573 30.9195 168.462 30.9565 168.346 30.9865C168.111 31.0412 167.88 31.1047 167.629 31.1473C167.147 31.2445 166.629 31.3034 166.104 31.3412L165.705 31.3631C165.574 31.3668 165.447 31.3654 165.315 31.3674C165.088 31.3784 164.726 31.3564 164.423 31.3483C163.973 31.33 163.404 31.2559 162.891 31.1608C161.824 30.9758 160.773 30.6893 159.679 30.4134C158.584 30.1375 157.41 29.8653 156.041 29.7597C155.364 29.7086 154.623 29.7119 153.954 29.8026C153.285 29.8915 152.699 30.0467 152.233 30.2262C152.002 30.3159 151.743 30.4215 151.587 30.504C151.492 30.555 151.432 30.5779 151.308 30.6481L151.053 30.7991C150.746 31.001 150.503 31.1993 150.267 31.3677C150.036 31.5362 149.781 31.6872 149.526 31.7945L149.343 31.8754C149.275 31.9018 149.171 31.9247 149.088 31.9512C149.012 31.9723 148.936 31.9935 148.86 32.0164C148.773 32.0306 148.689 32.0465 148.609 32.0642C148.275 32.1279 147.956 32.1863 147.638 32.2202C147.323 32.2576 147.036 32.302 146.769 32.313C146.498 32.3329 146.26 32.3509 146.052 32.3671C145.833 32.3728 145.65 32.3784 145.503 32.3822C145.216 32.3863 145.057 32.3902 145.057 32.3902Z"
          fill="#6ACBDD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M152.141 25.0279C152.213 25.0381 152.3 25.0517 152.406 25.067C152.513 25.0718 152.636 25.0748 152.776 25.0777C152.918 25.0858 153.07 25.0676 153.24 25.0547C153.41 25.0504 153.591 25.0077 153.786 24.9613C153.835 24.9506 153.885 24.9381 153.936 24.9274C153.987 24.9062 154.036 24.8867 154.088 24.8673C154.135 24.8461 154.18 24.8354 154.229 24.8072C154.279 24.7772 154.334 24.7437 154.387 24.7137C154.595 24.5816 154.754 24.4182 154.91 24.2443C155.21 23.8913 155.478 23.5594 155.862 23.3162C156.242 23.0661 156.675 22.9838 157.147 23.0815C157.624 23.1721 158.115 23.4395 158.628 23.712C159.144 23.9862 159.678 24.3006 160.305 24.5359C160.627 24.6483 160.949 24.7414 161.344 24.7694C161.506 24.7739 161.637 24.7909 161.832 24.7813C161.921 24.7791 162.015 24.777 162.103 24.7714L162.362 24.7387C163.052 24.6535 163.698 24.3113 164.148 23.9786C164.558 23.6881 164.907 23.6218 165.363 23.7686C165.424 23.7876 165.494 23.8048 165.548 23.8255L165.704 23.8861C165.807 23.9189 165.917 23.9814 166.022 24.0247C166.232 24.1236 166.437 24.2312 166.634 24.3405C166.832 24.4464 167.023 24.5541 167.216 24.6477C167.263 24.6703 167.312 24.6928 167.358 24.7154L167.393 24.7327L167.423 24.7466L167.44 24.7535L167.51 24.7795C167.604 24.814 167.688 24.8522 167.797 24.8762C168.206 24.9917 168.553 24.9744 168.832 24.9435C169.111 24.9073 169.317 24.8486 169.458 24.8095C169.596 24.7669 169.67 24.7456 169.67 24.7456C169.67 24.7456 169.594 24.7529 169.446 24.7641C169.302 24.777 169.087 24.7814 168.824 24.7773C168.563 24.7644 168.238 24.7133 167.939 24.5851C167.867 24.5609 167.782 24.5071 167.696 24.4619L167.632 24.4255L167.616 24.4168C167.636 24.4255 167.612 24.4133 167.612 24.4116L167.581 24.3907L167.458 24.309C167.293 24.1942 167.119 24.0725 166.936 23.9455C166.753 23.8168 166.556 23.6795 166.34 23.5457C166.225 23.4814 166.124 23.4136 165.989 23.3529C165.859 23.2888 165.728 23.2281 165.609 23.1866C165.35 23.0792 164.994 22.9933 164.633 23.0299C164.453 23.0411 164.274 23.0909 164.114 23.1546C164.032 23.1812 163.95 23.227 163.868 23.2676C163.777 23.3118 163.74 23.3434 163.671 23.3822L163.488 23.4933C163.433 23.525 163.379 23.562 163.322 23.592C163.207 23.6467 163.094 23.7102 162.971 23.7527C162.735 23.85 162.482 23.9088 162.224 23.9467L162.029 23.9685C161.965 23.9723 161.903 23.9708 161.838 23.9728C161.727 23.9838 161.55 23.9618 161.402 23.9537C161.181 23.9354 160.903 23.8614 160.651 23.7663C160.129 23.5813 159.615 23.2948 159.079 23.0189C158.543 22.743 157.968 22.4707 157.298 22.3652C156.966 22.3141 156.604 22.3174 156.276 22.4081C155.949 22.497 155.662 22.6522 155.434 22.8317C155.32 22.9214 155.194 23.0269 155.117 23.1095C155.071 23.1605 155.041 23.1833 154.981 23.2536L154.856 23.4046C154.706 23.6065 154.587 23.8047 154.471 23.9732C154.358 24.1417 154.233 24.2927 154.108 24.4L154.019 24.4809C153.985 24.5072 153.935 24.5302 153.894 24.5566C153.857 24.5778 153.82 24.599 153.782 24.6219C153.74 24.636 153.699 24.652 153.66 24.6696C153.496 24.7333 153.34 24.7918 153.184 24.8257C153.03 24.8631 152.889 24.9074 152.759 24.9185C152.626 24.9383 152.509 24.9563 152.408 24.9725C152.301 24.9782 152.211 24.9839 152.139 24.9877C151.998 24.9918 151.92 24.9956 151.92 24.9956C151.92 24.9956 151.996 25.0076 152.141 25.0279Z"
          fill="#6ACBDD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.686649 87.9156C0.686649 87.9156 0.841919 87.9275 1.13655 87.9478C1.28386 87.958 1.46301 87.9717 1.67801 87.9869C1.897 87.9917 2.14786 87.9947 2.43456 87.9976C2.72522 88.0057 3.03585 87.9876 3.38231 87.9746C3.72875 87.9704 4.09916 87.9276 4.49751 87.8812C4.59708 87.8705 4.70063 87.8581 4.80418 87.8473C4.90776 87.8261 5.00735 87.8067 5.11491 87.7872C5.21052 87.766 5.30212 87.7553 5.40173 87.7271C5.50533 87.6971 5.6169 87.6636 5.72447 87.6337C6.15082 87.5015 6.47371 87.3381 6.79265 87.1642C7.40661 86.8112 7.95282 86.4793 8.73775 86.2362C9.51475 85.986 10.3989 85.9037 11.3623 86.0014C12.3377 86.0921 13.3406 86.3594 14.3873 86.6319C15.442 86.9062 16.5324 87.2205 17.8141 87.4558C18.4708 87.5682 19.1277 87.6613 19.9359 87.6893C20.2664 87.6939 20.5332 87.7108 20.9314 87.7012C21.1145 87.6991 21.3057 87.6969 21.4849 87.6913L22.0146 87.6587C23.4243 87.5734 24.7431 87.2312 25.6636 86.8985C26.5004 86.608 27.2133 86.5418 28.1448 86.6885C28.2682 86.7075 28.4115 86.7247 28.523 86.7455L28.8414 86.806C29.0524 86.8388 29.2752 86.9014 29.4901 86.9446C29.92 87.0435 30.3379 87.1511 30.7399 87.2605C31.1458 87.3663 31.5358 87.474 31.9298 87.5677C32.0254 87.5902 32.1249 87.6127 32.2204 87.6353L32.292 87.6526L32.3517 87.6665L32.3875 87.6734L32.5308 87.6994C32.7219 87.734 32.893 87.7721 33.116 87.7961C33.9519 87.9116 34.6607 87.8943 35.2302 87.8634C35.7997 87.8272 36.2219 87.7686 36.5087 87.7294C36.7915 87.6869 36.9429 87.6655 36.9429 87.6655C36.9429 87.6655 36.7876 87.6729 36.4849 87.684C36.1902 87.6969 35.7522 87.7013 35.2146 87.6972C34.6811 87.6843 34.0162 87.6332 33.4073 87.505C33.26 87.4809 33.0849 87.427 32.9098 87.3819L32.7785 87.3454L32.7466 87.3367C32.7864 87.3454 32.7387 87.3332 32.7387 87.3315L32.675 87.3106L32.4243 87.2289C32.0861 87.1141 31.732 86.9924 31.3579 86.8655C30.9839 86.7368 30.582 86.5994 30.1403 86.4656C29.9055 86.4013 29.6986 86.3335 29.4239 86.2729C29.1573 86.2087 28.8906 86.148 28.6478 86.1065C28.1184 85.9992 27.3899 85.9132 26.6532 85.9498C26.2868 85.961 25.9204 86.0108 25.5937 86.0745C25.4264 86.1011 25.2591 86.147 25.0918 86.1876C24.9045 86.2317 24.8288 86.2634 24.6893 86.3022L24.3148 86.4132C24.2032 86.4449 24.0917 86.4819 23.9761 86.5119C23.7411 86.5666 23.51 86.6301 23.259 86.6726C22.777 86.7699 22.2592 86.8287 21.7335 86.8666L21.3353 86.8884C21.2039 86.8922 21.0765 86.8907 20.9451 86.8928C20.7181 86.9037 20.3558 86.8818 20.0532 86.8737C19.6032 86.8554 19.034 86.7813 18.5205 86.6862C17.4537 86.5012 16.4031 86.2147 15.3087 85.9388C14.2143 85.6629 13.0401 85.3907 11.6706 85.2851C10.9938 85.234 10.2531 85.2373 9.58393 85.328C8.91478 85.4169 8.32907 85.5721 7.86284 85.7516C7.6317 85.8413 7.37264 85.9469 7.21718 86.0294C7.1215 86.0804 7.06173 86.1032 6.93814 86.1735L6.68297 86.3245C6.37594 86.5264 6.13262 86.7246 5.89733 86.8931C5.66602 87.0616 5.41086 87.2126 5.15579 87.3199L4.97245 87.4008C4.9047 87.4272 4.80112 87.4501 4.71744 87.4766C4.64174 87.4977 4.56604 87.5189 4.49033 87.5418C4.40269 87.556 4.31904 87.5719 4.23937 87.5896C3.90476 87.6533 3.58608 87.7117 3.26745 87.7456C2.9528 87.783 2.66601 87.8274 2.3992 87.8384C2.12838 87.8583 1.88943 87.8763 1.68233 87.8924C1.46331 87.8982 1.28012 87.9038 1.13279 87.9076C0.846077 87.9117 0.686649 87.9156 0.686649 87.9156Z"
          fill="#6ACBDD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.77045 80.5533C7.84257 80.5635 7.93028 80.5771 8.03554 80.5924C8.14275 80.5972 8.26557 80.6002 8.40592 80.6031C8.54823 80.6112 8.7003 80.593 8.86992 80.5801C9.03952 80.5758 9.22087 80.533 9.41589 80.4867C9.46464 80.476 9.51534 80.4635 9.56603 80.4528C9.61674 80.4316 9.6655 80.4121 9.71815 80.3927C9.76496 80.3715 9.80981 80.3608 9.85857 80.3326C9.90929 80.3026 9.96391 80.2691 10.0166 80.2391C10.2253 80.107 10.3834 79.9436 10.5395 79.7697C10.8401 79.4166 11.1075 79.0848 11.4918 78.8416C11.8722 78.5915 12.3051 78.5092 12.7767 78.6069C13.2542 78.6975 13.7452 78.9649 14.2577 79.2374C14.774 79.5116 15.3078 79.826 15.9353 80.0613C16.2569 80.1736 16.5785 80.2667 16.9741 80.2948C17.1359 80.2993 17.2665 80.3163 17.4615 80.3067C17.5512 80.3045 17.6447 80.3024 17.7325 80.2967L17.9918 80.2641C18.682 80.1789 19.3276 79.8366 19.7783 79.504C20.1879 79.2135 20.5369 79.1472 20.993 79.294C21.0534 79.313 21.1236 79.3302 21.1781 79.3509L21.334 79.4115C21.4373 79.4443 21.5464 79.5068 21.6516 79.5501C21.8621 79.6489 22.0667 79.7565 22.2635 79.8659C22.4622 79.9718 22.6531 80.0795 22.846 80.1731C22.8928 80.1957 22.9415 80.2182 22.9883 80.2408L23.0234 80.2581L23.0526 80.272L23.0701 80.2789L23.1403 80.3048C23.2338 80.3394 23.3176 80.3776 23.4267 80.4016C23.836 80.5171 24.183 80.4998 24.4618 80.4689C24.7406 80.4327 24.9473 80.374 25.0877 80.3349C25.2262 80.2923 25.3003 80.271 25.3003 80.271C25.3003 80.271 25.2243 80.2783 25.0761 80.2895C24.9318 80.3023 24.7174 80.3068 24.4542 80.3027C24.193 80.2898 23.8675 80.2387 23.5694 80.1105C23.4973 80.0863 23.4115 80.0325 23.3258 79.9873L23.2615 79.9509L23.2459 79.9422C23.2654 79.9508 23.242 79.9387 23.242 79.937L23.2109 79.9161L23.0881 79.8344C22.9225 79.7196 22.7492 79.5979 22.566 79.4709C22.3829 79.3422 22.1862 79.2048 21.9699 79.0711C21.855 79.0068 21.7537 78.939 21.6192 78.8783C21.4887 78.8142 21.3581 78.7535 21.2392 78.712C20.9801 78.6046 20.6234 78.5187 20.2627 78.5552C20.0834 78.5665 19.904 78.6163 19.744 78.68C19.6621 78.7066 19.5802 78.7524 19.4983 78.793C19.4066 78.8372 19.3696 78.8688 19.3013 78.9076L19.1179 79.0187C19.0633 79.0504 19.0087 79.0874 18.9521 79.1174C18.837 79.1721 18.7239 79.2356 18.601 79.2781C18.3651 79.3754 18.1116 79.4342 17.8542 79.4721L17.6592 79.4939C17.5949 79.4977 17.5325 79.4962 17.4682 79.4982C17.3571 79.5092 17.1797 79.4872 17.0315 79.4791C16.8113 79.4608 16.5326 79.3868 16.2812 79.2916C15.7589 79.1067 15.2446 78.8202 14.7088 78.5443C14.173 78.2684 13.5981 77.9961 12.9276 77.8905C12.5963 77.8395 12.2337 77.8428 11.9061 77.9335C11.5785 78.0224 11.2917 78.1776 11.0635 78.3571C10.9503 78.4468 10.8235 78.5523 10.7474 78.6349C10.7005 78.6858 10.6713 78.7087 10.6108 78.779L10.4858 78.93C10.3355 79.1319 10.2164 79.3301 10.1012 79.4986C9.98797 79.6671 9.86304 79.8181 9.73817 79.9254L9.64841 80.0062C9.61524 80.0326 9.56453 80.0556 9.52356 80.082C9.4865 80.1032 9.44944 80.1243 9.41238 80.1473C9.36947 80.1614 9.32852 80.1774 9.28951 80.195C9.12569 80.2587 8.96968 80.3171 8.81369 80.3511C8.65964 80.3885 8.51924 80.4328 8.38861 80.4439C8.25603 80.4637 8.13904 80.4817 8.03765 80.4979C7.93043 80.5036 7.84074 80.5093 7.76861 80.5131C7.62824 80.5172 7.55019 80.521 7.55019 80.521C7.55019 80.521 7.62621 80.5329 7.77045 80.5533Z"
          fill="#6ACBDD"
        />
        <g filter="url(#filter0_d_2386_92178)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M116.719 19.8542C119.228 29.2112 121.819 35.389 124.493 38.3877C126.929 41.121 130.73 43.0314 135.896 44.1188C136.774 44.3037 137.644 43.7741 137.883 42.9094C139.551 36.8859 139.392 32.346 137.407 29.2895C135.26 25.9839 131.17 21.0772 125.136 14.5693L116.719 19.8542Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M116.445 19.1424C119.722 28.8325 122.675 35.2287 125.302 38.3311C127.652 41.105 131.141 42.9365 135.769 43.8256C136.691 44.0026 137.581 43.399 137.758 42.4775C137.761 42.4606 137.764 42.4436 137.767 42.4266C138.652 36.925 138.102 32.6472 136.119 29.5932C133.939 26.2359 129.754 21.2722 123.566 14.7022L116.445 19.1424Z"
            fill="#4E8B7C"
          />
          <path
            opacity="0.31685"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M132.157 40.1904L130.625 38.5414C130.199 38.0832 130.225 37.3664 130.683 36.9405C130.731 36.896 130.783 36.8558 130.838 36.8202L133.172 35.3039C133.697 34.9631 134.399 35.1122 134.74 35.6369C134.775 35.6917 134.806 35.7495 134.831 35.8096L135.715 37.8803C135.93 38.3867 135.751 38.975 135.29 39.2748L133.604 40.3693C133.142 40.6691 132.532 40.5936 132.157 40.1904Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M117.707 20.3997C119.773 27.027 121.781 31.4407 123.731 33.6407C126.657 36.9408 135.787 30.4526 133.429 26.822C131.857 24.4017 128.686 20.9236 123.915 16.388L117.707 20.3997Z"
            fill="#121626"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M122.444 31.8767C122.963 32.7056 123.81 34.0238 124.983 35.8311C125.725 36.9729 129.234 37.0044 131.498 35.5002C133.919 33.8917 134.89 31.1808 134.391 29.3851C134.058 28.188 133.312 26.9173 132.151 25.5732C133.075 28.5565 132.138 30.9568 129.34 32.774C126.542 34.5912 124.243 34.2921 122.444 31.8767Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M119.91 19.2676L118.282 16.7609L121.207 14.8618L121.869 15.8813L122.835 17.3684L119.91 19.2676Z"
            fill="#121626"
          />
          <path
            d="M133.406 32.5797L131.402 30.7133"
            stroke="#232F3E"
            strokeWidth="0.918048"
            strokeLinecap="square"
          />
          <path
            d="M128.799 35.3665C128.775 35.6314 128.642 35.5224 128.398 35.0396C128.155 34.5568 127.85 33.7973 127.485 32.7611"
            stroke="#232F3E"
            strokeWidth="0.918048"
            strokeLinecap="square"
          />
        </g>
        <g filter="url(#filter1_d_2386_92178)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.5738 69.6075C39.5738 69.6075 36.7713 76.1172 39.421 82.2489C42.0706 88.3806 54.2092 101.97 54.2092 101.97C54.2092 101.97 56.3533 101.844 58.907 100.121C61.4606 98.3987 62.687 96.9116 62.687 96.9116C62.687 96.9116 54.5331 79.3146 50.1465 75.0145C45.7598 70.7143 39.5885 69.6294 39.5885 69.6294L39.5738 69.6075Z"
            fill="#232F3E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.5534 69.2945C38.5534 69.2945 36.9635 75.1047 39.8316 81.2922C42.6996 87.4797 54.8486 101.62 54.8486 101.62C54.8486 101.62 56.8221 101.643 59.0652 100.13C61.3082 98.6171 62.3404 97.244 62.3404 97.244C62.3404 97.244 53.6013 79.4494 49.2527 74.9376C44.9039 70.4257 38.5534 69.2945 38.5534 69.2945Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.4606 71.1953C39.4606 71.1953 37.038 77.7349 44.976 87.0186C44.976 87.0186 45.4911 85.8707 48.1497 84.0775C50.8083 82.2842 52.0656 82.2366 52.0656 82.2366C52.0656 82.2366 48.8763 72.0213 40.0689 70.785L39.4606 71.1953Z"
            fill="#E8282F"
          />
          <path
            opacity="0.250873"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M57.1894 100C56.2306 100.647 54.7807 100.174 53.9513 98.9445L46.4175 88.7287C45.588 87.4989 45.6928 85.9777 46.6517 85.3309L50.7826 82.5445C51.7414 81.8978 53.1912 82.3705 54.0207 83.6002L60.582 94.4721C61.4114 95.7018 61.3066 97.2231 60.3478 97.8698L57.1894 100Z"
            fill="#232F3E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M59.4961 97.0488L61.8259 100.503L58.4805 102.759L57.3552 101.091L56.1507 99.3053L59.4961 97.0488Z"
            fill="#121626"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M54.2278 88.8762L50.7536 91.2196C49.6989 91.9311 48.4645 91.9454 47.9966 91.2517L43.5098 85.6487C43.0419 84.9549 43.5176 83.8159 44.5723 83.1044L49.1163 80.0395C50.1711 79.328 51.4054 79.3137 51.8734 80.0074L55.2903 86.332C55.7583 87.0257 55.2825 88.1648 54.2278 88.8762Z"
            fill="#232F3E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M45.8384 87.0498C45.5389 86.6057 45.8557 85.8681 46.5461 85.4025L46.9272 85.1454C47.6177 84.6797 48.4201 84.6623 48.7196 85.1064L49.3421 86.0293L46.4609 87.9727L45.8384 87.0498Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.8795 84.999C48.5799 84.5549 48.9132 83.8063 49.6238 83.327L50.016 83.0624C50.7266 82.5831 51.5456 82.5545 51.8451 82.9986L52.5432 83.8705L49.502 85.9219L48.8795 84.999Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M46.867 88.5742C47.0001 88.7716 47.6677 88.5541 48.3581 88.0884L48.7392 87.8314C49.4297 87.3657 49.8813 86.8282 49.7482 86.6308L49.4715 86.2207L46.5903 88.1641L46.867 88.5742Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M49.908 86.5235C50.0411 86.7208 50.7252 86.4923 51.4358 86.0129L51.828 85.7484C52.5386 85.2691 53.0068 84.7205 52.8737 84.5231L52.6726 84.0619L49.6313 86.1133L49.908 86.5235Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.6711 85.2247C42.6711 85.2247 42.1965 83.2057 45.9718 81.0979L47.8695 83.9113C47.8695 83.9113 45.6914 85.3804 45.227 86.5709L42.6711 85.2247Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M51.4149 79.3279C51.4149 79.3279 49.7206 78.1316 46.3521 80.8423L48.2497 83.6558C48.2497 83.6558 50.4278 82.1867 51.7056 82.202L51.4149 79.3279Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M46.3422 81.0721L46.7223 80.8157L42.0628 73.9076L41.6826 74.1641L46.3422 81.0721Z"
            fill="white"
          />
        </g>
        <mask
          id="mask0_2386_92178"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="69"
          y="37"
          width="44"
          height="44"
        >
          <rect
            x="69.1001"
            y="37.6367"
            width="43.1876"
            height="43.1565"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_2386_92178)">
          <path
            d="M92.1786 58.6748V50.9876C92.1786 50.598 92.0512 50.2758 91.7962 50.0211C91.5413 49.7663 91.2189 49.6389 90.829 49.6389C90.4391 49.6389 90.1167 49.7663 89.8618 50.0211C89.6069 50.2758 89.4794 50.598 89.4794 50.9876V59.2143C89.4794 59.3941 89.5094 59.5589 89.5694 59.7088C89.6294 59.8586 89.7193 60.0085 89.8393 60.1583L96.3174 66.8566C96.5874 67.1563 96.9248 67.2986 97.3296 67.2837C97.7345 67.2687 98.0719 67.1263 98.3418 66.8566C98.6118 66.5869 98.7467 66.2572 98.7467 65.8676C98.7467 65.478 98.6118 65.1483 98.3418 64.8786L92.1786 58.6748ZM90.694 77.1962C88.2348 77.1962 85.9104 76.7241 83.7211 75.7801C81.5317 74.836 79.6197 73.5473 77.9852 71.914C76.3507 70.2806 75.061 68.3701 74.1163 66.1823C73.1716 63.9945 72.6992 61.6718 72.6992 59.2143C72.6992 56.7568 73.1716 54.4341 74.1163 52.2463C75.061 50.0585 76.3507 48.1479 77.9852 46.5146C79.6197 44.8812 81.5317 43.5925 83.7211 42.6485C85.9104 41.7044 88.2348 41.2324 90.694 41.2324C93.1533 41.2324 95.4777 41.7044 97.667 42.6485C99.8564 43.5925 101.768 44.8812 103.403 46.5146C105.037 48.1479 106.327 50.0585 107.272 52.2463C108.217 54.4341 108.689 56.7568 108.689 59.2143C108.689 61.6718 108.217 63.9945 107.272 66.1823C106.327 68.3701 105.037 70.2806 103.403 71.914C101.768 73.5473 99.8564 74.836 97.667 75.7801C95.4777 76.7241 93.1533 77.1962 90.694 77.1962ZM90.694 74.4989C94.8928 74.4989 98.4918 73.0004 101.491 70.0034C104.49 67.0064 105.99 63.4101 105.99 59.2143C105.99 55.0185 104.49 51.4221 101.491 48.4252C98.4918 45.4282 94.8928 43.9297 90.694 43.9297C86.4953 43.9297 82.8963 45.4282 79.8971 48.4252C76.898 51.4221 75.3984 55.0185 75.3984 59.2143C75.3984 63.4101 76.898 67.0064 79.8971 70.0034C82.8963 73.0004 86.4953 74.4989 90.694 74.4989Z"
            fill="#1C1B1F"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_2386_92178"
          x="111.444"
          y="11.5684"
          width="32.5811"
          height="39.5879"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_92178"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_92178"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2386_92178"
          x="33.1138"
          y="66.2949"
          width="34.5732"
          height="43.4648"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2386_92178"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2386_92178"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2386_92178">
          <rect
            width="182"
            height="125.861"
            fill="white"
            transform="translate(0 0.00195312)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ReportsBlankSvg = () => {
  return (
    <svg
      width="153"
      height="91"
      viewBox="0 0 153 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.151578">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M129.267 28.7172C122.721 35.9852 115.587 36.3395 104.96 30.6735C94.3324 25.0075 97.8104 13.5779 104.356 6.30987C109.215 0.914134 115.471 -2.90699 121.178 3.43764C122.316 4.70306 122.571 6.38844 122.79 8.1592L122.822 8.4189C122.827 8.46228 122.833 8.50569 122.838 8.54914L122.87 8.81024L122.903 9.07197C123.198 11.3424 123.668 13.6583 126.046 15.3371C130.009 18.1349 135.812 21.4492 129.267 28.7172Z"
          fill="#6ACBDD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M98.9425 76.3944C81.7345 93.9267 63.7989 94.0559 37.7535 78.7135C11.708 63.3712 21.6723 35.0747 38.8804 17.5424C51.6556 4.52657 67.7642 -4.39127 81.3917 12.1293C84.2422 15.585 84.6047 20.0958 84.976 24.7979L85.0281 25.4551C85.511 31.4898 86.1981 37.7715 92.3143 42.4926C101.951 49.9318 116.151 58.8621 98.9425 76.3944Z"
          fill="#6ACBDD"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6797 27.0663C18.6797 27.0663 18.7415 27.0783 18.8587 27.1002C18.9173 27.1111 18.9886 27.1249 19.0741 27.1411C19.1618 27.1532 19.2623 27.1661 19.3772 27.1806C19.4934 27.1974 19.6189 27.2047 19.7585 27.2156C19.8977 27.2301 20.0483 27.2302 20.2103 27.2303C20.2508 27.2306 20.2929 27.2305 20.335 27.231C20.3775 27.2273 20.4184 27.2242 20.4624 27.2214C20.5018 27.2174 20.5391 27.2174 20.5803 27.2107C20.6233 27.2036 20.6696 27.1954 20.7142 27.1884C20.8914 27.1554 21.0286 27.105 21.1647 27.0502C21.4276 26.9375 21.6622 26.8302 21.9885 26.7694C22.312 26.7055 22.6706 26.7138 23.0525 26.7978C23.4397 26.8796 23.8295 27.0334 24.2368 27.1914C24.6471 27.3504 25.0699 27.5271 25.5732 27.6811C25.8314 27.7567 26.0906 27.8246 26.4136 27.8735C26.546 27.8907 26.6522 27.91 26.8124 27.9247C26.886 27.9324 26.9628 27.9404 27.035 27.9465L27.249 27.9582C27.8186 27.9898 28.3638 27.9143 28.7486 27.824C29.098 27.7468 29.3871 27.7535 29.754 27.8557C29.8026 27.8691 29.8593 27.8826 29.903 27.8961L30.028 27.9352C30.1111 27.9582 30.1976 27.9936 30.2818 28.021C30.4496 28.0806 30.6123 28.1432 30.7684 28.2057C30.9264 28.267 31.0778 28.3283 31.2315 28.3842C31.2688 28.3977 31.3077 28.4114 31.3449 28.4248L31.3729 28.4351L31.3962 28.4435L31.4102 28.4479L31.4665 28.465C31.5416 28.4877 31.6084 28.511 31.6968 28.531C32.0268 28.6162 32.312 28.6424 32.5419 28.6565C32.7721 28.6686 32.9442 28.6648 33.0611 28.6625C33.1766 28.6587 33.2383 28.6572 33.2383 28.6572C33.2383 28.6572 33.1757 28.6529 33.0537 28.6432C32.9349 28.6347 32.7589 28.616 32.5434 28.5893C32.3299 28.5592 32.0656 28.5078 31.8272 28.428C31.7693 28.4115 31.7016 28.3818 31.6334 28.3555L31.5824 28.3348L31.57 28.3298C31.5856 28.3352 31.567 28.3281 31.5671 28.3274L31.5425 28.3161L31.4458 28.2717C31.3154 28.2099 31.179 28.1447 31.0349 28.0764C30.8908 28.0074 30.736 27.9337 30.565 27.8595C30.4738 27.8228 30.394 27.786 30.2866 27.749C30.1826 27.7108 30.0785 27.6741 29.983 27.6462C29.7756 27.5785 29.4873 27.5101 29.19 27.4904C29.0425 27.4778 28.8932 27.4806 28.7591 27.4909C28.6908 27.4937 28.6215 27.5043 28.5524 27.5127C28.4752 27.5217 28.4434 27.5308 28.3856 27.5398L28.2302 27.5668C28.1839 27.5743 28.1374 27.5839 28.0897 27.5906C27.9928 27.6015 27.8971 27.6161 27.7944 27.6215C27.5965 27.6379 27.386 27.6373 27.1733 27.628L27.0125 27.6181C26.9596 27.6135 26.9085 27.607 26.8557 27.6017C26.7641 27.5955 26.6198 27.5698 26.4987 27.5524C26.3191 27.5241 26.0941 27.4679 25.8926 27.4059C25.4732 27.2821 25.0651 27.1184 24.6389 26.9569C24.2126 26.7954 23.7543 26.6316 23.2097 26.5254C22.9405 26.4734 22.6432 26.4402 22.3705 26.4453C22.0978 26.4497 21.8556 26.4845 21.6601 26.5346C21.5632 26.5598 21.4543 26.5899 21.3881 26.6157C21.3473 26.6317 21.3223 26.638 21.2694 26.6604L21.16 26.709C21.0273 26.7755 20.9204 26.8435 20.8182 26.9C20.7175 26.9566 20.608 27.0052 20.5007 27.0362L20.4234 27.0601C20.3949 27.0675 20.3523 27.0718 20.3175 27.0785C20.2861 27.0834 20.2548 27.0884 20.2233 27.094C20.1875 27.0956 20.1532 27.0981 20.1204 27.1015C19.9832 27.1113 19.8526 27.1199 19.7231 27.1186C19.5952 27.1189 19.478 27.1233 19.3704 27.1153C19.2609 27.1106 19.1641 27.1066 19.0803 27.1034C18.9921 27.0955 18.9184 27.0892 18.8591 27.0839C18.7439 27.0722 18.6797 27.0663 18.6797 27.0663Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9408 21.4613C12.9408 21.4613 13.0027 21.4728 13.1198 21.4956C13.1783 21.507 13.2496 21.5203 13.3351 21.5368C13.4211 21.5577 13.5193 21.5827 13.6315 21.6115C13.7457 21.6386 13.8651 21.678 13.9989 21.7191C14.1336 21.7569 14.2737 21.8121 14.4243 21.8717C14.462 21.8862 14.5012 21.9019 14.5404 21.9168C14.5786 21.9359 14.6155 21.9538 14.6554 21.9726C14.6905 21.9908 14.7251 22.0045 14.7611 22.0259C14.7984 22.0483 14.8384 22.073 14.8772 22.0959C15.0298 22.1918 15.1387 22.289 15.245 22.39C15.4478 22.5914 15.6263 22.7775 15.9072 22.9539C16.1843 23.1323 16.5207 23.2564 16.9068 23.3188C17.2969 23.3851 17.7161 23.3854 18.153 23.3884C18.5932 23.3915 19.0515 23.3826 19.5762 23.4245C19.8442 23.4492 20.1103 23.4814 20.4286 23.5547C20.558 23.5873 20.6639 23.6085 20.8182 23.6538C20.8895 23.6737 20.9639 23.6944 21.0332 23.7153L21.2365 23.7832C21.7777 23.9632 22.2566 24.2338 22.581 24.4593C22.8772 24.6596 23.1485 24.7596 23.5273 24.7995C23.5774 24.805 23.6352 24.8132 23.6808 24.8167L23.8114 24.8263C23.8971 24.8355 23.9906 24.8344 24.079 24.8399C24.2571 24.8462 24.4314 24.8479 24.5996 24.8471C24.7691 24.8482 24.9325 24.8469 25.0961 24.8515C25.1357 24.8527 25.1769 24.8543 25.2165 24.8554L25.2463 24.8561L25.271 24.857L25.2857 24.858L25.3443 24.8628C25.4225 24.8693 25.4933 24.8722 25.5828 24.8861C25.921 24.9282 26.1958 25.0088 26.4148 25.0802C26.6332 25.1536 26.7919 25.2204 26.8997 25.2655C27.0056 25.3116 27.0624 25.3356 27.0624 25.3356C27.0624 25.3356 27.0026 25.3166 26.8857 25.2807C26.772 25.245 26.6015 25.1977 26.3914 25.1433C26.1818 25.0927 25.917 25.0433 25.666 25.0298C25.606 25.0239 25.5321 25.0266 25.4591 25.0259L25.404 25.0264L25.3907 25.0265C25.4071 25.0273 25.3872 25.027 25.387 25.0277L25.36 25.0292L25.2536 25.0349C25.1097 25.0444 24.9588 25.0549 24.7996 25.0653C24.6402 25.0765 24.469 25.0881 24.2827 25.0942C24.1844 25.0947 24.0965 25.0996 23.983 25.0946C23.8723 25.0918 23.7619 25.0877 23.6628 25.0785C23.445 25.0652 23.1518 25.0227 22.8681 24.9318C22.7264 24.8892 22.5886 24.8317 22.4677 24.7728C22.4052 24.745 22.3447 24.7098 22.2837 24.6765C22.2152 24.6398 22.189 24.6196 22.1386 24.59L22.004 24.5077C21.9638 24.4838 21.9241 24.4577 21.8822 24.434C21.7962 24.3882 21.7126 24.3394 21.6192 24.2967C21.4412 24.2086 21.2453 24.1318 21.0441 24.0623L20.891 24.0123C20.8401 23.9971 20.7902 23.9844 20.7392 23.97C20.6518 23.942 20.5081 23.9128 20.3892 23.8845C20.2117 23.8447 19.9818 23.8143 19.7715 23.7978C19.3359 23.7587 18.8961 23.7608 18.4402 23.7542C17.9843 23.7476 17.4977 23.7313 16.9523 23.6298C16.6829 23.5792 16.3942 23.5007 16.1425 23.3957C15.8907 23.2914 15.6784 23.1699 15.5152 23.0515C15.4343 22.9924 15.3443 22.9244 15.2922 22.876C15.2602 22.8462 15.2393 22.8311 15.1984 22.7909L15.1146 22.7055C15.0159 22.5949 14.9416 22.4923 14.8674 22.4022C14.7947 22.3125 14.7109 22.2272 14.6226 22.1588L14.5595 22.1082C14.5358 22.0909 14.4978 22.0712 14.4679 22.0522C14.4406 22.036 14.4132 22.0199 14.3861 22.0031C14.3534 21.9884 14.3224 21.9735 14.2931 21.9583C14.1692 21.8987 14.051 21.8427 13.9302 21.7963C13.8113 21.749 13.704 21.7019 13.6011 21.6697C13.4974 21.6338 13.4061 21.6019 13.327 21.574C13.2421 21.549 13.1712 21.5277 13.1141 21.5109C13.0027 21.4794 12.9408 21.4613 12.9408 21.4613Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M122.908 73.3437C122.908 73.3437 122.969 73.3591 123.085 73.3872C123.143 73.4013 123.213 73.419 123.298 73.4397C123.384 73.4565 123.484 73.4748 123.598 73.4955C123.713 73.5186 123.838 73.5325 123.977 73.551C124.115 73.5729 124.266 73.5812 124.427 73.59C124.468 73.5925 124.51 73.5946 124.552 73.5974C124.594 73.596 124.635 73.5951 124.68 73.5947C124.719 73.5928 124.756 73.5948 124.798 73.5904C124.841 73.5855 124.888 73.5798 124.933 73.5753C125.111 73.5519 125.251 73.509 125.39 73.4616C125.659 73.3632 125.899 73.2687 126.228 73.2256C126.554 73.1792 126.912 73.2068 127.289 73.3113C127.671 73.4138 128.052 73.5884 128.45 73.768C128.851 73.9489 129.264 74.1481 129.758 74.329C130.012 74.4184 130.267 74.5002 130.587 74.5664C130.718 74.5908 130.823 74.6157 130.982 74.639C131.055 74.6507 131.132 74.6628 131.203 74.6728L131.416 74.696C131.983 74.7582 132.532 74.7122 132.921 74.6428C133.274 74.5845 133.562 74.6068 133.923 74.7286C133.971 74.7445 134.027 74.7611 134.07 74.777L134.192 74.8228C134.274 74.8502 134.359 74.8902 134.441 74.9221C134.606 74.9906 134.765 75.0619 134.917 75.1327C135.072 75.2025 135.22 75.2718 135.37 75.3359C135.406 75.3514 135.445 75.3671 135.481 75.3826L135.508 75.3944L135.531 75.4039L135.545 75.4091L135.6 75.4292C135.674 75.456 135.739 75.4828 135.827 75.5075C136.152 75.6104 136.435 75.6519 136.664 75.6784C136.893 75.7029 137.065 75.7084 137.182 75.7124C137.297 75.7148 137.359 75.7166 137.359 75.7166C137.359 75.7166 137.297 75.7089 137.175 75.6927C137.057 75.6777 136.883 75.6496 136.669 75.6113C136.457 75.5699 136.196 75.5042 135.962 75.4118C135.905 75.3921 135.839 75.3588 135.773 75.3289L135.723 75.3055L135.711 75.2999C135.726 75.306 135.708 75.2979 135.708 75.2972L135.684 75.2846L135.59 75.2351C135.463 75.1664 135.331 75.0939 135.19 75.018C135.05 74.9413 134.9 74.8594 134.733 74.7761C134.644 74.7346 134.566 74.6935 134.461 74.6507C134.359 74.607 134.257 74.5647 134.163 74.5317C133.96 74.4529 133.676 74.3691 133.38 74.3334C133.233 74.3129 133.084 74.3077 132.95 74.3107C132.881 74.3099 132.811 74.3167 132.742 74.3214C132.664 74.3262 132.632 74.3336 132.574 74.3395L132.417 74.358C132.371 74.363 132.324 74.3701 132.276 74.3742C132.178 74.3799 132.082 74.3893 131.979 74.3891C131.781 74.3949 131.57 74.383 131.359 74.3622L131.199 74.3437C131.146 74.3362 131.095 74.3269 131.043 74.3188C130.952 74.3077 130.809 74.2742 130.689 74.2504C130.511 74.2124 130.29 74.1442 130.092 74.0714C129.68 73.9252 129.281 73.7397 128.864 73.5555C128.447 73.3713 127.998 73.1831 127.46 73.0477C127.194 72.9813 126.899 72.9321 126.627 72.9225C126.354 72.9122 126.111 72.9339 125.913 72.9734C125.814 72.9933 125.704 73.0176 125.637 73.0398C125.595 73.0535 125.57 73.0585 125.516 73.078L125.404 73.1206C125.268 73.1798 125.157 73.242 125.052 73.2929C124.949 73.344 124.837 73.3866 124.728 73.4119L124.649 73.4315C124.62 73.4373 124.578 73.4394 124.543 73.4442C124.511 73.4474 124.479 73.4507 124.448 73.4546C124.412 73.4543 124.377 73.4549 124.344 73.4565C124.207 73.459 124.076 73.4605 123.947 73.4522C123.819 73.4456 123.702 73.4437 123.595 73.4299C123.486 73.4193 123.389 73.4101 123.306 73.4025C123.218 73.3898 123.145 73.3795 123.086 73.371C122.972 73.3531 122.908 73.3437 122.908 73.3437Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.775 69.2297C117.775 69.2297 117.838 69.2332 117.957 69.2407C118.017 69.2445 118.089 69.2485 118.176 69.2539C118.264 69.2636 118.365 69.2758 118.48 69.2899C118.596 69.3021 118.72 69.3258 118.858 69.3495C118.996 69.3696 119.142 69.4064 119.299 69.4461C119.339 69.4556 119.38 69.4661 119.42 69.4759C119.461 69.4899 119.5 69.503 119.542 69.5165C119.579 69.53 119.615 69.5392 119.653 69.5557C119.693 69.5732 119.736 69.5925 119.778 69.6102C119.941 69.6857 120.062 69.7682 120.18 69.8546C120.407 70.0283 120.608 70.19 120.91 70.3288C121.207 70.4701 121.557 70.55 121.948 70.5622C122.343 70.5779 122.759 70.5244 123.193 70.4712C123.63 70.4177 124.083 70.3501 124.609 70.3243C124.878 70.3143 125.146 70.3121 125.471 70.3438C125.603 70.3596 125.711 70.367 125.87 70.392C125.943 70.4026 126.02 70.4137 126.091 70.4254L126.302 70.4666C126.862 70.5757 127.371 70.7825 127.722 70.9644C128.042 71.125 128.324 71.1894 128.704 71.1803C128.755 71.1793 128.813 71.18 128.859 71.1776L128.99 71.1704C129.076 71.1685 129.168 71.1554 129.257 71.1495C129.434 71.1329 129.607 71.1121 129.774 71.0898C129.942 71.0691 130.104 71.0468 130.267 71.0303C130.306 71.0264 130.347 71.0227 130.387 71.0188L130.416 71.0156L130.441 71.0133L130.456 71.0124L130.515 71.0097C130.593 71.006 130.663 70.9999 130.754 71.0021C131.095 71.0005 131.378 71.0451 131.604 71.0877C131.83 71.1325 131.996 71.1783 132.109 71.2092C132.22 71.2413 132.279 71.2579 132.279 71.2579C132.279 71.2579 132.218 71.2467 132.097 71.2261C131.98 71.2053 131.804 71.1802 131.589 71.1533C131.375 71.13 131.106 71.1151 130.855 71.1339C130.795 71.1358 130.722 71.148 130.649 71.1567L130.595 71.1643L130.582 71.166C130.598 71.1647 130.578 71.167 130.578 71.1677L130.552 71.1727L130.447 71.192C130.305 71.2198 130.157 71.2496 130 71.2805C129.844 71.312 129.676 71.3455 129.492 71.3755C129.394 71.3887 129.308 71.4047 129.194 71.4144C129.084 71.4258 128.974 71.4359 128.875 71.4396C128.657 71.4543 128.361 71.4499 128.068 71.3961C127.922 71.3721 127.778 71.3327 127.65 71.2899C127.585 71.2704 127.52 71.2432 127.455 71.2181C127.383 71.1905 127.354 71.1738 127.3 71.1509L127.156 71.0866C127.113 71.068 127.071 71.0473 127.026 71.0291C126.935 70.9948 126.846 70.9571 126.747 70.9268C126.559 70.8623 126.355 70.8112 126.147 70.7681L125.989 70.7382C125.936 70.7297 125.885 70.7236 125.833 70.7158C125.742 70.6993 125.596 70.6888 125.474 70.676C125.293 70.6593 125.061 70.6586 124.851 70.6693C124.414 70.6865 123.978 70.7451 123.525 70.7971C123.072 70.8492 122.587 70.8955 122.033 70.8648C121.76 70.8492 121.463 70.8085 121.2 70.7367C120.937 70.6656 120.711 70.5724 120.533 70.4759C120.446 70.4278 120.348 70.3718 120.29 70.3306C120.254 70.3051 120.231 70.2928 120.186 70.2582L120.092 70.1843C119.979 70.0873 119.893 69.9951 119.807 69.9153C119.724 69.8357 119.63 69.7618 119.533 69.7053L119.464 69.6633C119.438 69.6491 119.398 69.6345 119.366 69.6194C119.337 69.607 119.308 69.5945 119.279 69.5813C119.244 69.571 119.212 69.5602 119.181 69.5489C119.05 69.5056 118.926 69.4653 118.8 69.4348C118.676 69.4032 118.563 69.3702 118.457 69.3516C118.35 69.3292 118.255 69.3093 118.173 69.2919C118.085 69.2779 118.012 69.2659 117.954 69.2566C117.839 69.2397 117.775 69.2297 117.775 69.2297Z"
        fill="#6ACBDD"
      />
      <g filter="url(#filter0_d_3675_114352)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M145.847 54.2362C140.259 46.1165 135.671 41.0727 132.084 39.1048C128.749 37.2753 125.354 36.441 119.872 37.2165C119.15 37.3187 118.543 37.7418 118.588 38.4689C118.421 44.0911 119.769 49.9158 122.763 52.2105C125.949 54.6513 131.545 57.9677 139.553 62.1596L145.847 54.2362Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M146.775 53.031C141.187 44.9113 136.599 39.8675 133.012 37.8996C129.677 36.0701 125.269 35.5431 119.787 36.3186C119.064 36.4208 118.542 37.0608 118.587 37.7878C118.995 44.3048 120.696 48.7106 123.691 51.0053C126.876 53.4462 132.473 56.7626 140.481 60.9545L146.775 53.031Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M147.281 53.6211C140.841 45.4426 135.832 40.312 132.253 38.2292C128.974 36.3208 124.882 35.7673 119.975 36.5689C119.213 36.6934 118.696 37.4108 118.82 38.1714C118.821 38.1757 118.822 38.1801 118.822 38.1845C119.821 43.9449 121.822 47.9761 124.826 50.2778C128.061 52.7568 133.768 56.0959 141.946 60.295L147.281 53.6211Z"
          fill="#6ACBDD"
        />
        <path
          opacity="0.31685"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M124.868 38.6847L127.3 39.9542C127.756 40.1922 127.932 40.7542 127.694 41.2095C127.669 41.257 127.64 41.3023 127.607 41.3448L125.556 44.0095C125.242 44.417 124.657 44.4938 124.249 44.181C124.206 44.1484 124.166 44.1121 124.13 44.0726L122.273 42.0554C121.967 41.7227 121.945 41.2182 122.221 40.8597L123.696 38.9426C123.972 38.5841 124.467 38.4753 124.868 38.6847Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M145.64 52.8435C141.405 47.1906 137.977 43.6405 135.356 42.1932C131.424 40.0222 124.854 49.3407 128.352 52.0213C130.684 53.8084 134.913 56.0667 141.037 58.7962L145.64 52.8435Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M137.19 43.4474C136.41 42.8289 135.149 41.8524 133.408 40.5181C132.308 39.6752 128.926 40.8355 127.261 43.0458C125.481 45.4092 125.468 48.3374 126.557 49.8895C127.283 50.9243 128.432 51.889 130.004 52.7836C128.102 50.2375 128.188 47.6186 130.259 44.9271C132.331 42.2355 134.641 41.7423 137.19 43.4474Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M143.91 54.6792L146.325 56.5299L144.16 59.3429L143.178 58.5901L141.745 57.4922L143.91 54.6792Z"
          fill="#121626"
        />
        <path
          d="M126.42 46.4925L128.979 47.6019"
          stroke="#232F3E"
          strokeWidth="0.918048"
          strokeLinecap="square"
        />
        <path
          d="M129.898 42.2583C129.831 41.9962 129.997 42.0553 130.395 42.4356C130.793 42.8159 131.343 43.4408 132.046 44.3104"
          stroke="#232F3E"
          strokeWidth="0.918048"
          strokeLinecap="square"
        />
      </g>
      <g filter="url(#filter1_d_3675_114352)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.87224 75.1543C7.28863 77.57 8.48069 78.7999 9.39088 79.7079C8.71227 80.1413 11.2503 81.8612 13.371 83.4896C23.0419 77.8106 30.2889 71.4045 33.6481 65.0119C38.6869 55.4229 39.3051 51.9534 37.9562 50.6077C36.6073 49.262 33.7484 51.5248 25.2868 55.8353C20.182 59.8423 13.2621 65.4237 5.87224 75.1543Z"
          fill="#332F3D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.4135 74.7299C6.82989 77.1457 8.02195 78.3755 8.93214 79.2836C8.25353 79.717 10.7915 81.4368 12.9122 83.0653C22.5832 77.3863 29.8301 70.9802 33.1893 64.5876C38.2281 54.9986 38.8464 51.5291 37.4975 50.1834C36.1486 48.8377 33.2897 51.1005 24.828 55.411C19.7232 59.418 12.8033 64.9994 5.4135 74.7299Z"
          fill="#E8282F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.40935 74.6148C6.58896 76.8251 7.58136 78.3319 8.38654 79.1352C9.19173 79.9385 10.7474 81.1301 13.0535 82.7101C22.1862 76.8744 28.595 70.773 32.2799 64.406C37.8072 54.8555 38.4085 50.9969 37.4344 49.8899C36.4603 48.7829 32.3235 50.8565 23.9045 55.6013C18.2919 58.7645 12.1268 65.1024 5.40935 74.6148Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.86632 75.3134C7.75633 76.9589 8.50246 78.0821 9.10471 78.6829C9.70697 79.2838 10.8679 80.1778 12.5874 81.3649C17.5367 78.1795 21.3521 74.2429 24.0334 69.5553C28.0555 62.5238 28.3861 61.1059 27.4936 60.2155C26.6011 59.325 23.4273 61.9716 17.2281 65.4228C13.0953 67.7237 9.64138 71.0205 6.86632 75.3134Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0544 69.1611L13.417 70.168L15.1432 70.1678L16.8816 68.7709L19.0387 70.9229L17.6825 72.5896L19.1914 74.2065L19.539 75.6527C25.4504 68.5577 29.4018 63.3559 31.3932 60.0472C32.2131 58.685 29.5742 55.6609 27.985 56.647C24.1766 59.01 18.8664 63.1814 12.0544 69.1611Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0513 68.2716L14.7477 68.2807L16.26 69.8898L17.7938 68.601L19.3382 70.1417L18.0883 71.6134L19.422 72.944L19.7103 74.3129C24.873 67.7721 28.4118 63.0732 30.3268 60.2161C31.1152 59.0398 29.2621 56.8387 27.8867 57.7817C24.5908 60.0417 19.979 63.5383 14.0513 68.2716Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.5305 60.5941L12.0292 75.0647C11.7908 75.3026 11.7908 75.6882 12.0292 75.9261C12.0317 75.9286 12.0343 75.9311 12.0368 75.9336C12.2849 76.1725 12.6791 76.1691 12.923 75.9258L27.4243 61.4552C27.6627 61.2173 27.6626 60.8317 27.4243 60.5938C27.4217 60.5913 27.4192 60.5888 27.4166 60.5863C27.1686 60.3473 26.7743 60.3508 26.5305 60.5941Z"
          fill="#ECECEC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.2616 59.0075L26.5552 59.7126C26.2651 60.0021 26.2652 60.4714 26.5553 60.7608L27.2619 61.4657C27.552 61.7552 28.0223 61.7551 28.3123 61.4656L29.0188 60.7606C29.3088 60.4711 29.3088 60.0018 29.0187 59.7124L28.3121 59.0074C28.022 58.718 27.5517 58.7181 27.2616 59.0075Z"
          fill="#ECECEC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.30025 77.5178L7.5938 78.2228C7.30374 78.5123 7.30379 78.9816 7.59389 79.271L8.88623 80.5603C9.17633 80.8498 9.64665 80.8497 9.9367 80.5602L10.6432 79.8552C10.9332 79.5657 10.9332 79.0964 10.6431 78.807L9.35073 77.5177C9.06062 77.2283 8.5903 77.2283 8.30025 77.5178Z"
          fill="#232F3E"
        />
      </g>
      <rect
        x="47.5957"
        y="18.2859"
        width="62.1349"
        height="59.1429"
        rx="4"
        fill="#232F3E"
      />
      <g clipPath="url(#clip0_3675_114352)">
        <rect
          x="47.023"
          y="16.5715"
          width="61.2759"
          height="59.1429"
          rx="4"
          fill="white"
        />
        <rect
          x="47.023"
          y="27.4287"
          width="61.2759"
          height="1.42857"
          fill="#232F3E"
        />
        <mask
          id="mask0_3675_114352"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="57"
          y="31"
          width="41"
          height="41"
        >
          <rect
            x="57.6175"
            y="31.7144"
            width="40.3734"
            height="40.2857"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_3675_114352)">
          <path
            d="M65.1875 66.9643C64.5146 66.9643 63.9258 66.7125 63.4211 66.2089C62.9165 65.7054 62.6641 65.1179 62.6641 64.4464V36.75H65.1875V64.4464H92.9441V66.9643H65.1875ZM68.3416 61.2991V47.283H73.3462V61.2991H68.3416ZM76.6686 61.2991V38.6384H81.6732V61.2991H76.6686ZM84.8274 61.2991V54.1652H89.832V61.2991H84.8274Z"
            fill="#232F3E"
          />
        </g>
      </g>
      <g filter="url(#filter2_d_3675_114352)">
        <path
          d="M61.3398 14.0001C61.3398 12.1066 62.8782 10.5715 64.7759 10.5715C66.6735 10.5715 68.2119 12.1066 68.2119 14.0001V19.143C68.2119 21.0365 66.6735 22.5715 64.7759 22.5715C62.8782 22.5715 61.3398 21.0365 61.3398 19.143V14.0001Z"
          fill="#232F3E"
        />
      </g>
      <g filter="url(#filter3_d_3675_114352)">
        <path
          d="M89.1144 14.0001C89.1144 12.1066 90.6528 10.5715 92.5504 10.5715C94.4481 10.5715 95.9865 12.1066 95.9865 14.0001V19.143C95.9865 21.0365 94.4481 22.5715 92.5504 22.5715C90.6528 22.5715 89.1144 21.0365 89.1144 19.143V14.0001Z"
          fill="#232F3E"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3675_114352"
          x="113.575"
          y="32.9724"
          width="38.7066"
          height="36.1873"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3675_114352"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3675_114352"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3675_114352"
          x="0.409363"
          y="46.5981"
          width="43.1642"
          height="43.8914"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3675_114352"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3675_114352"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_3675_114352"
          x="56.3398"
          y="7.57153"
          width="16.8721"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0666667 0 0 0 0 0.0823529 0 0 0 0 0.14902 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3675_114352"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3675_114352"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_3675_114352"
          x="84.1144"
          y="7.57153"
          width="16.8721"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0666667 0 0 0 0 0.0823529 0 0 0 0 0.14902 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3675_114352"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3675_114352"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3675_114352">
          <rect
            x="47.023"
            y="16.5715"
            width="61.2759"
            height="59.1429"
            rx="4"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
